var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeSplashWhite1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "7.06298cm",
    height: "6.93352cm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 3301.11 3240.6",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Conte\\xFAdo_x0020_do_x0020_PowerClip"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2623563436976"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2608583901504"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M664.95 3195.41c5.04,5.37 8.53,11.57 8.6,21.68 -2.12,10.16 -7.88,14.73 -13.96,18.7 -11.07,7.21 -25.83,6.13 -32.88,-1.91 -7.92,-8.82 -7.08,-21.76 2.19,-32.46 2.4,-2.72 4.94,-5.32 7.65,-7.68 9.8,-8.33 19.62,-7.74 28.41,1.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M669.01 2942.83c-1.95,0.79 -4.69,-0.15 -8.99,-1.75 -2.62,-2.47 -3.52,-3.36 -3.87,-4.44 -4.64,-14.27 -2.97,-20.49 6.03,-23.23 9.49,-2.85 18.48,0.83 20.72,8.5 2.66,9.13 -1.38,15.52 -13.9,20.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2033.83 1325.25c-11.01,9.24 -7.49,21.3 -6.57,32.24 1.86,22.89 -6.32,41.35 -21.67,57.42 -3.96,4.18 -8.04,8.3 -12.01,12.49 -2.88,3.07 -3.26,6.82 -1.55,12.18 0.05,0.07 0.05,0.15 0.08,0.21 0.13,-0.44 0.24,-0.93 0.45,-1.4 5.2,4.25 6.62,8.26 1.12,10.83 -0.14,1.18 -0.36,2.42 -0.57,3.82 -1.07,6.04 -1.54,10.07 -2.12,15.85 -0.02,0.15 -0.09,0.27 -0.11,0.43 0.36,-0.38 0.71,-0.8 1.1,-1.11 1.42,5.27 1.37,9.45 -3.58,10.21 -0.3,1.09 -0.61,2.25 -0.89,3.56 0.06,4.14 0.1,6.51 -0.36,10.53 -0.03,0.1 -0.08,0.2 -0.13,0.31 0.55,-0.33 1.03,-0.66 1.62,-0.92 0.99,6.48 -2.06,8.96 -6.58,8.73 -1,0.88 -2.1,1.79 -3.51,2.64 -8.46,5.04 -15.34,1.79 -21.34,-0 -8.77,-2.65 -16.3,-5.36 -23.36,3.1 -0.79,0.95 -5.95,-0.17 -7.65,-1.82 -2.78,-2.76 -3.37,-6.73 -0.45,-10.38 3.41,-4.2 10.4,-6.76 6.78,-14.16 -2.67,-5.63 -7.74,-8.38 -13.5,-10.1 -4.66,-1.36 -9.2,-3.62 -13.9,-4.17 -10.84,-1.39 -18.15,-6.37 -20.64,-17.32 -1.52,-6.75 -6.12,-10.41 -12.52,-9.51 -25.12,3.51 -44.13,-10.35 -64.3,-21.44 -8.91,-4.88 -11.37,-12.92 -12.07,-21.76 -0.33,-4.71 1.25,-9.57 1.65,-14.4 0.64,-8.02 -0.99,-14.63 -7.98,-20.43 -12.68,-10.42 -24.36,-21.61 -25.93,-40.1 -0.53,-6.7 -8.14,-10.86 -15.77,-10.03 -10.41,1.14 -21.08,6.3 -31.02,-0.57 -9.43,-6.6 -8.62,-19.08 -14.19,-28.17 -5.18,-8.36 0.19,-14.98 10.24,-13.6 5.66,0.77 11.19,2.74 16.77,4.37 24.3,7.08 48.43,-1.74 62.71,-22.89 2.69,-3.99 5.9,-7.67 8.56,-11.69 7.55,-11.48 14.12,-23.08 10.08,-37.97 -2.65,-9.89 2.97,-16.85 11.61,-21.01 5.17,-2.45 10.82,-4.2 16.33,-5.79 4,-1.13 8.9,-0.17 10.14,3.48 4.71,13.65 19.16,11.67 27.97,18.52 7.59,5.94 16,6.33 24.5,1.36 12.22,-7.07 24.78,-3.72 36.74,-0.09 11.03,3.32 21.39,8.71 31.57,17.48 0.07,-0.29 0.11,-0.56 0.22,-0.88 3.3,-3.29 4.96,-5.64 5.83,-8.27 1.62,-4.86 4.08,-8.35 9.79,-8.28 6.15,0.16 10.77,2.96 13.88,8.19 3.57,6 1.08,14.31 -5.36,16.3 -5.45,1.7 -11.88,0.73 -17.16,4.8 0.21,1.37 0.39,2.75 0.53,4.29 7.17,13.61 13.66,25.32 21.19,38.45 0.09,0.18 0.16,0.31 0.29,0.49 0.02,-0.56 0,-1.12 0.07,-1.66 5.48,3.01 7.88,6.36 3.78,9.95 0.26,1.19 0.43,2.52 0.57,4 0.89,7.14 3.88,10.6 7.65,13.9 7.21,6.36 14.06,13.17 20.92,19.9 2.8,2.79 5.69,6.93 2.06,9.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M833.95 1818.9c11.9,3.97 23.87,8.43 36.21,10.5 13.46,2.2 23.94,9.26 32.46,18.19 13.32,13.93 25.13,29.3 33.09,47.44 7.31,16.65 4.34,32.19 -1.58,47.79 -3.1,8.13 -8.53,15.38 -11.08,23.59 -5.2,16.48 -17.74,25.69 -32.13,31.49 -11.41,4.6 -23.6,8.75 -36.51,9.13 -18.36,0.47 -36.75,1.72 -57.5,2.35 -28.3,-4.04 -48.16,-19.95 -69.68,-33.18 -15.39,-9.45 -23.28,-23.15 -28.17,-39.06 -3.37,-11.01 -5.36,-22.53 -8.17,-33.76 -3.85,-15.27 -1.54,-30.78 12.48,-41.92 8.3,-6.62 16.98,-13.06 23.9,-21.01 21.11,-24.01 46.9,-32.55 78.24,-27.23 9.56,1.6 19.14,2.6 28.43,5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M637.73 2235.66c-7.31,0.65 -12.2,1.57 -16.98,1.22 -27.37,-1.43 -52.44,-7.48 -73.94,-27.08 -13.83,-12.59 -18.24,-27.67 -24.35,-43.99 -6.33,-16.88 -3.9,-29.89 5.04,-43.47 5.85,-8.87 11.6,-17.84 18.23,-26.12 5.15,-6.39 11.3,-13.06 19.4,-14.79 14.86,-3.19 29.62,-7.66 45.2,-7.17 33.89,1.13 65.17,9.18 89.27,34.84 21.88,23.32 26.42,53.3 7.4,85.02 -15.05,25.12 -38.77,36.76 -69.26,41.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1634.13 1886.66c-15.79,8.35 -34.9,11.99 -53.45,3.6 -6.12,-2.74 -12.76,-4.52 -19.18,-6.56 -19.5,-6.26 -38.15,-13.91 -51.92,-30.15 -1.83,-2.08 -4.44,-4.71 -6.83,-4.83 -5.95,-0.31 -8.71,-1.32 -5.75,-7.92 1.05,-2.43 0.86,-5.89 0.06,-8.54 -7.72,-26.73 3.35,-46.36 22.12,-64.35 7.28,-6.93 14.47,-12.35 23.86,-15.59 13.23,-4.61 26.53,-5.68 40.08,-2.29 13.4,3.32 26.73,3.62 40.37,1.46 6.61,-1 13.54,-0.09 22.44,0.69 0.46,0.15 0.82,0.38 1.26,0.55 -0.33,-0.57 -0.72,-1.13 -1.01,-1.72 6.62,-0.67 11.28,-1.04 16.76,-0.69 -0.09,-0.9 -0.11,-1.83 -0.12,-2.87 -4.07,-13.63 7.46,-17.78 11.07,-30.66 3.61,9.4 7.58,13.38 12.1,16.81 7.42,5.6 13.21,13.23 9.85,21.95 -3.08,7.95 -12.46,5.85 -21.64,6.64 0.31,0.54 0.63,1.01 0.96,1.58 -0.49,8.89 2.37,17.14 -7.39,19.21 -0.13,1.41 -0.19,2.75 -0.43,4.23 -0.59,5.95 -1.35,10.06 -0.21,13.59 4.87,14.59 1.5,29.04 -0.79,43.23 -3.15,19.48 -16.33,34.24 -32.21,42.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2393.34 950.37c0.06,-0.13 0.06,-0.24 0.1,-0.38 4.89,1.35 7.02,3.63 6.14,6.82 0.61,1.13 1.15,2.35 1.74,3.77 4.48,5.51 7.58,9.69 12.17,15.86 0.13,0.37 0.31,0.71 0.49,1.06 0.01,-0.79 -0.04,-1.61 0.04,-2.4 8.46,6.09 6.16,15.1 10.34,21.43 2.19,3.39 6.09,3.8 8.69,0.07 1.06,-1.54 1.37,-3.63 2.43,-5.16 8.18,-11.36 15.6,-11.36 24.72,-0.09 3.19,3.94 5.43,7.96 2.23,12.89 -3.39,5.13 -7.83,8.45 -14.3,7.29 -5.48,-0.93 -10.67,-5.88 -16.26,-2.62 -6.83,4.02 -4.52,11.79 -5.65,18.13 -0.47,2.79 -0.16,5.95 -1.41,8.31 -1.79,3.41 -4.86,5.28 -8.61,1.44 -0.73,0.91 -1.4,1.79 -2.2,2.66 -4.05,2.66 -6.77,4.46 -10.23,8.21l-0.02 0c0.44,-0.01 0.87,-0.13 1.32,-0.1 2.42,7.23 4.56,12.47 5.99,17.97 0.27,1.18 -1.41,3.75 -2.79,4.41 -1.49,0.71 -4.65,0.64 -5.39,-0.37 -3.52,-4.78 -6.52,-9.9 -8.63,-15.76 -1.36,-0.01 -2.89,-0.27 -4.69,-0.82 -8.35,0.2 -14.23,1.2 -19.9,0.55 -14.46,-1.78 -25.71,1.98 -35.54,13.76 -7.82,9.35 -16.16,9 -25.33,1.16 -6.59,-5.56 -12.95,-11.81 -17.78,-18.88 -8.87,-12.86 -7.91,-28.15 2.56,-39.87 6.99,-7.82 12.11,-17.65 21.74,-22.88 5.61,-3.08 7.52,-8.27 9.88,-13.68 4.91,-11.09 5.34,-22.26 3.32,-34.02 -1.22,-7.22 2.26,-10.11 9.86,-10.93 21.71,-2.26 40.09,3.55 54.98,22.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2953.28 551.88c-4.05,-14.21 -9.41,-27.47 -0.64,-43.82 8.92,-16.61 12.57,-35.96 28.2,-48.81 1.93,-1.57 1.79,-5.45 3.14,-8.02 2.64,-5.17 5.1,-10.5 8.48,-15.17 6.64,-9.21 16.3,-13.88 27.41,-12.81 9.52,0.96 8.83,11.63 13.3,17.59 3.8,5.12 1.8,11.18 2.43,19.03 6.18,13.9 0.77,24.22 -7.16,30.85 -9.05,7.75 -10.24,16.08 -7.28,25.65 3.78,11.99 0.07,23.14 -2.23,34.32 -4.94,24 -37.21,34.64 -54.71,18.05 -4.74,-4.51 -9.17,-10.64 -10.95,-16.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1895.58 1624.62c-8.88,4.27 -17.5,7.01 -27.91,3.94 -12.97,-3.85 -13.18,-2.98 -14.37,11.23 -0.29,3.86 -0.4,7.79 -1.22,11.53 -2.87,12.93 -12.08,19.15 -25.28,18.77 -17.46,-0.49 -27.35,-12.4 -37.75,-23.71 -2.81,-3.02 -1.53,-7.29 -0.72,-11.17 4.15,-19.51 25.29,-30.34 45.41,-22.84 6.02,2.28 10.53,12.68 16.75,8.32 8.99,-6.3 -3.19,-13.11 -2.99,-20.35 0.19,-5.78 -0.24,-11.52 0.02,-19.24 0.08,-0.13 0.12,-0.26 0.16,-0.38 -0.35,0.03 -0.62,0.12 -1.01,0.14 -3.51,-11.63 -6.67,-21.19 -8.02,-31.43 -1.24,-0.04 -2.52,-0.29 -4,-0.66 -8.93,-1.75 -13.64,-6.57 -18.74,-11.01 -3.39,-2.94 -4.26,-6.14 -2.79,-10.07 1.37,-3.87 4.63,-6.09 8.33,-7.24 7.88,-2.36 15.13,-0.86 21.66,4.16 6.97,5.39 8.38,12.34 3.91,22.09 0.76,0.08 1.53,0.18 2.35,0.47 3.28,7.16 8.25,9.24 12.88,12.49 1.15,-0.37 2.28,-0.72 3.68,-0.93 3.68,0.78 6.46,0.83 7.16,2.04 7.58,13.57 17.99,23.97 31.15,32.25 3.98,2.52 4.71,7.93 3.75,13.21 -1.47,8.07 -4.64,14.66 -12.44,18.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M957.34 1536.36c4.71,7.11 5.48,14.59 -0.64,21.18 -6.77,7.27 -11.43,15.43 -13.94,27.16 -4.38,7.66 -10.27,10.65 -15.14,6.06 -8.14,-7.5 -17.44,-11.68 -27.75,-14.52 -10.95,-2.99 -17.41,-11.06 -23.82,-19.8 -9.03,-12.26 -1.59,-30.86 10.23,-37.18 25.34,-13.58 55.39,-6.47 71.07,17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1602 1211.14c-0.43,3.71 -6.87,5.85 -9.1,2.87 -6.09,-8.1 -14.3,-11.41 -23.65,-14.52 -11.06,-3.53 -19.63,-11.78 -26.01,-21.85 -6.49,-10.26 -2.46,-20.47 -0.02,-30.62 2.44,-9.8 11.45,-8.77 20.55,-11.03 7.74,-1.52 13.43,-1.9 18.23,2.34 5.78,5.08 11.49,10.21 17.46,15.06 15.01,12.25 18.02,22.89 8.24,39.28 -3.7,6.19 -5,11.87 -5.7,18.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1618 1056.97c5.13,15.72 19.43,26.35 23.2,44.96 -5.11,22.64 -10.4,28.39 -25.07,25.6 -18.71,-3.57 -33.69,-13.64 -41.92,-31.62 -3.67,-8 1.13,-32.75 7.23,-38.18 1.94,-1.74 4.94,-2.71 7.62,-3.3 5.63,-1.28 11.31,-2.01 16.99,-3.05 5.36,-0.97 10.34,0.76 11.95,5.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2692.64 659.99c-3.37,1.64 -7.88,1.76 -9.32,5.9 -2.47,7.22 -2.86,15.9 -11.8,18.54 -10.86,3.15 -7.52,14.68 -13.41,20.96 -9.68,10.35 -26.07,8.57 -30.55,-4.76 -2.95,-8.88 -2.99,-18.76 -11.06,-25.34 -1.37,-15.77 16.93,-5.05 20.31,-15.21 1.06,-3.32 5.94,-5.29 7.52,-8.58 3.76,-7.83 8.23,-12.47 17.83,-9.48 4.12,1.25 7.5,-2.17 8.73,-5.9 1.91,-5.47 2.7,-11.31 8.64,-16.95 2.71,-1.44 3.69,-1.86 4.6,-1.71 14.34,1.1 15.03,13.39 17.42,23 1.93,7.7 -0.72,15.53 -8.9,19.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2146.16 1464.03c-3.63,-1.64 -6.5,-3.61 -8.42,-5.89 4.13,0.23 6.87,2.4 8.42,5.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2137.56 1458.1c-4.64,-0.15 -6.88,-2.04 -7.75,-6.38 -1.59,-8.11 -6.46,-11.59 -14.58,-9.28 -5.96,1.68 -11.98,2.28 -15.82,-3.08 -5.95,-8.34 -18.25,-12.86 -17.41,-25.22 0.87,-12.84 -2.11,-25.94 3.38,-39.36 -0.86,-0.5 -1.7,-1.01 -2.65,-1.56 -7.83,-9.23 -15.62,-16.6 -17.62,-30.74 11.91,4.77 22.35,8.84 34.22,4.25 8.64,-3.35 16.45,7.58 11.83,16.21 -3.08,5.8 -7.78,10.85 -13.07,15.95 0.55,0.87 1.06,1.88 1.53,3.06 11.53,2.19 20.49,7.95 32.4,5.16 -0.27,-0.16 -0.57,-0.34 -0.84,-0.55 7.7,-5.42 8.46,-5.57 8.96,1.24 0.94,0.72 1.86,1.6 2.75,2.93 2.77,6.15 3.67,11.19 9.43,16.27 0.02,0.08 0.04,0.15 0.08,0.24 0.22,-0.79 0.4,-1.58 0.74,-2.36 8.88,0.1 14.76,2.68 20.02,6.79 3.95,3.01 8.33,3.99 13.7,4.83 0.92,2.6 1.44,3.43 1.86,4.3 3.81,7.45 1.2,13.03 -5.6,16.59 -4.82,2.48 -9.29,0.27 -12.32,-3.9 -4.49,-6.21 -9.62,-10.97 -17.95,-12.54 -0.54,1.26 -1.24,2.54 -2.12,3.87 -5.52,7.14 -10.55,11.9 -13.81,17.64 -3.31,5.94 -2.88,11.33 0.79,15.69 -0.06,-0.02 -0.12,-0.04 -0.17,-0.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2149.92 1464.64c4.19,1.3 6.96,4.22 2.51,7.37 -2.86,2.06 -4.56,-2.19 -5.21,-4.93 -0.24,-1.09 -0.65,-2.1 -1.07,-3.04 0.33,0.14 0.59,0.31 0.93,0.47 0.78,0.36 1.97,-0.13 2.83,0.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2666.47 1141.53c-4.2,5.3 -8.16,10.47 -11.5,16.41 -3.67,6.44 -12.99,5.37 -16.55,-1.52 -3.51,-6.74 -5.1,-13.9 -11.26,-19.79 -13.19,-12.65 -16.3,-27.82 -3.93,-45.79 3.36,-5.96 5.23,-11.18 11.41,-9.83 6.55,1.4 12.9,3.92 19.49,5.08 12.53,2.16 10.55,2.68 16.38,17.69 5.64,14.42 5.01,26.39 -4.05,37.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2686.62 1909.85c7.71,-14.36 29.95,-19.12 43.05,-9.81 5.42,3.91 9.98,9.09 12.39,17.95 3.39,16.48 1.33,29.42 -13.07,36.74 -12.22,6.23 -24.32,3.84 -35.44,-3.86 -15.09,-10.45 -15.22,-25.55 -6.93,-41.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M178.76 1154.66c-1.8,8.92 -10.28,15.8 -21.56,16.31 -5.66,0.25 -11.65,-0.64 -17.06,-2.37 -8.26,-2.65 -16.11,-6.59 -25.76,-11.26 -2.78,-2.85 -4.44,-4.17 -5.18,-5.87 -6.59,-14.97 -4.27,-21.69 9.34,-27.57 17.67,-7.72 34.55,-4.4 49.89,5.31 8.46,5.39 12.49,14.75 10.34,25.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1124.15 1230.85c13.55,-1.49 21.27,7.88 29.72,15.55 13.07,11.99 14.02,21.25 4.75,35.7 -5.9,9.18 -14.2,11.9 -25.17,8.58 -14.08,-4.23 -23.44,-13.2 -29.21,-28.8 -4.14,-9.05 -6.09,-15.93 -0.79,-23.56 5.49,-7.97 13.11,-6.65 20.71,-7.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1970.05 931.22c2.84,0.03 5.71,0.65 8.58,1.12 6.53,1.03 8.36,-2.61 8.33,-8.23 -0.07,-21.18 0.32,-21.85 19.41,-16.32 5.89,1.69 11.33,1.95 16.97,1.36 9.94,-1.05 13.47,10.47 22.5,11.03 1.75,6.8 6.18,13.2 3.45,21.11 -1.91,-1.42 -4.1,-2.08 -4.66,-3.46 -2.75,-6.67 -5.33,-12.7 -14.54,-8.37 -3.41,1.64 -7.4,1.93 -11.07,3.03 -12.16,3.65 -24.06,7.14 -25.31,23.31 -0.36,4.6 -5.28,7.82 -11.16,10.17 -0.3,0.36 -0.56,0.6 -0.79,0.89 -3.6,8.38 0.73,12.97 2.22,18.32 3.05,10.88 1.46,13.33 -10.97,18.7 -1.74,0.78 -3.67,1.04 -6.4,-0.21 -1.53,-2.5 -2.21,-3.18 -2.79,-3.94 -14.38,-19.57 -13.85,-22.64 6.34,-33.94 0.09,0 0.38,0.07 1,0.29 0.19,0.08 0.35,0.14 0.52,0.25 -0.38,-0.38 -0.76,-0.71 -1.24,-1.22 -4.32,-4.85 -6.45,-6.89 -8.88,-8.47 -5.91,-3.96 -11.58,-8.95 -8.46,-16.37 2.78,-6.49 9.67,-9.17 16.94,-9.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2795.68 881.18c-4.58,-3.75 -9,-7.39 -14.91,-12.23 -15.27,-25.48 -15.21,-25.47 -14.05,-54.36 0.06,-1.79 -1.82,-4.04 -1.22,-5.3 1.74,-3.42 1.57,0.01 1.99,0.78 7.52,13.22 15.19,-0.03 22.57,0.15 15.06,0.36 17.61,1.43 23.27,15.76 3.85,9.58 4.36,18.61 -0.63,27.61 -2.75,5.01 -5.54,10.17 -9.18,14.55 -3.36,4.04 0.73,12.52 -7.83,13.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2599 1208.74c-3.13,-4.13 -5.15,-8.25 -2.67,-13.12 6.2,-12.51 24.95,-14.69 33.51,-4.09 3.2,3.85 5.17,8.05 5.41,13.05 0.53,10.51 2.23,21.1 1.22,31.41 -0.71,7.16 1.21,10.82 6.75,13.92 0.82,0.45 1.55,1.19 2.07,1.93 3.91,5.51 2.58,11.38 -3.26,14.46 -5.05,2.66 -9.69,1.51 -12.57,-2.95 -2.5,-3.73 -0.51,-11.3 -5.47,-12.36 -10.68,-2.29 -21.58,-9.3 -34.03,-2.83 -0.14,0.85 -0.31,1.72 -0.57,2.65 -4.33,1.72 -7.13,2.23 -9.86,3.17 -4.41,1.41 -9.03,4.13 -12.29,-1.55 -2.81,-4.87 -0.67,-9.09 2.7,-12.76 5.73,-6.41 12.25,-8.78 20.15,-2.1 -0.01,0.09 -0.01,0.14 -0.01,0.2 0.71,-0.66 1.52,-1.35 2.57,-2.01 11.97,-7.88 14.14,-16.81 6.38,-27.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2784.31 1663.44c-0.57,-5.15 0.51,-9.48 6.28,-11.36 3.65,-1.16 7.82,-2.09 10.54,-4.46 8.71,-7.67 16.15,-3.47 23.13,2.11 6.96,5.53 11.28,13.25 14.17,21.54 4,11.92 0.1,18.93 -11.39,25.63 -8.4,4.89 -16.47,4.55 -26.92,1.29 -10.18,-10.61 -14.43,-22.15 -15.81,-34.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1829.72 1104.38c-11.3,1.91 -20.67,-0.77 -28.54,-9.7 -12.06,-13.65 -12.58,-19.14 -0.57,-42.79 4.3,-3.81 8.19,-6.33 11.62,-4.41 8.28,4.78 16.44,10.06 23.81,16.13 5.99,5.02 8.9,12.53 9.81,20.36 1.08,9.88 -6.17,18.7 -16.12,20.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1372.63 1084.36c14.54,-2.88 38.4,11.07 44.78,24.88 2.56,5.51 3.6,10.88 -0.24,16.19 -4.79,6.77 -12.51,10.04 -20.01,7.9 -14.33,-4.01 -26.71,-10.64 -33.44,-24.84 -0.14,-0.06 -0.29,-0.12 -0.44,-0.19 -0.1,0.05 -0.14,0.14 -0.26,0.22 -16.98,3.79 -22.47,2.67 -20.29,-2.25 3.81,-8.36 11.2,-3.43 17.05,-4.3 0.06,-0.01 0.14,0.03 0.2,0.01 0.5,-0.53 1.12,-1.11 2.08,-1.72 -1.89,-10.45 3.98,-14.62 10.58,-15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2131.81 924.07c-4.16,2.99 -8.83,4.23 -13.63,3.08 -17.09,-4.04 -27.34,-30.59 -17.57,-44.75 3.73,-5.35 11.72,-8.08 17.86,-6.43 11.61,3.04 16.1,16.16 27.65,19.57 1.26,0.41 -1.05,7.15 0.49,9.86 -5.56,6.58 -8.17,13.98 -14.8,18.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2400.01 1415.55c-8.02,-11.01 -13.67,-23.23 -15.76,-36.69 -1.16,-7.18 4.69,-14.95 11.59,-18.14 7.09,-3.26 12.95,-1.2 18.5,3.5 7.91,6.59 12.79,14.23 9.9,26.94 0.69,5.63 2.12,9.25 2.61,13.1 0.66,5.78 0.46,11.68 -5.82,14.89 -6.99,3.56 -16.73,2.29 -21.02,-3.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2403.07 1561.95c-2.71,0.23 -5.75,-0.15 -8.38,-1.11 -7.61,-2.72 -12.3,-14.26 -10.3,-24.72 1.75,-8.98 9.36,-16.62 17.25,-16.5 8.81,0.18 17.25,1.82 24.71,10.96 6.25,5.99 6.23,11.8 6.35,17.56 0.15,6.84 -2.64,10.57 -9.82,11.17 -6.65,0.53 -13.18,2 -19.82,2.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1951.45 1656.95c1.89,-2.76 7.31,-2.08 10.88,-0.1 4.67,2.62 6.86,7.49 5.67,12.2 -2.63,10.03 -6.14,19.91 -9.96,29.59 -0.81,2.17 -4.16,4.09 -6.71,4.65 -6.81,1.54 -13.4,-0.1 -19.4,-3.54 -5.73,-3.22 -7.09,-8.67 -7.45,-16.59 6.34,-13.13 19.94,-15.88 26.96,-26.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2404.04 912.72c-6.8,-0.44 -9.28,-5.82 -10.52,-11.78 -1.39,-6.76 -0.66,-13.34 3.06,-21.37 7.56,-8.35 13.86,-8.2 21.4,-2.9 12.6,8.82 12.1,25.43 22.06,35.79 0.58,0.59 -0.83,3.53 -1.74,5.09 -1.66,2.94 -5.31,3.96 -7.36,2.53 -8.22,-5.61 -17.4,-6.69 -26.89,-7.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1518.15 1280.29c7.02,1.21 12.98,7.73 12.53,17.09 -0.45,9.06 0.48,16.48 6.03,24.2 3.86,5.33 -0.43,10.45 -7.05,14.87 0.55,0.15 1.09,0.25 1.71,0.5 5.59,3.69 10.22,4.96 14.14,7.35 5.57,3.53 6.68,10.45 3.1,14.67 -3.72,4.38 -12.74,5.92 -15.07,1.51 -4.46,-8.17 -13.76,-13.13 -14.32,-22.98 -0.79,-0.8 -1.59,-1.87 -2.31,-3.34 -3.02,-12 -11.35,-17.75 -17.45,-25.08 -3.23,-3.89 -4.82,-8.48 -3.42,-13.45 2.57,-9.04 13.99,-16.77 22.12,-15.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M805.37 2634.96c1.72,2.15 2.93,4.94 3.67,7.6 1.66,6.02 -0.12,11.31 -5.39,17.35 -6.21,6.92 -12.41,8.34 -19.51,7.48 -7.75,-0.82 -16.02,-1.54 -19.38,-9.66 -3.76,-9.03 1.07,-16.83 6.71,-23.53 6.43,-7.57 27.78,-6.92 33.91,0.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2962.75 1233.52c-18.4,-17.03 -18.26,-17.92 -11.82,-31.22 4.13,-8.58 11.64,-8.91 18.78,-10.75 12.67,-3.27 15.05,-1.75 17.6,10.6 4.33,20.73 -0.91,28.14 -24.57,31.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2346.46 1270.7c-0.12,7.14 -10.36,17.26 -16.75,17.46 -8.95,0.3 -22.93,-10.64 -25.74,-20.04 -3.4,-11.52 0.44,-16.6 11.18,-22.61 8.31,-4.62 17.07,2.16 24.19,-1.07 6.98,8.83 7.27,17.66 7.12,26.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1214.24 2278.98c-8.23,-2.57 -13.18,-9.74 -13.44,-19.51 -0.13,-6.04 4.39,-10.61 12.56,-13.52 8.51,-3.01 16.75,-3.23 26.39,2.55 5.83,7.94 10.33,14.51 4.68,22.27 -6.08,8.32 -13.99,12.6 -24.63,9.56 -1.83,-0.5 -3.74,-0.76 -5.57,-1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2687.25 1491.45c-2.96,-8.25 -0.41,-15.72 7.91,-22.96 7.44,-6.47 12.61,-7.5 21.02,-2.7 6.64,3.75 12.7,8.56 19.24,13.03 -4.17,4.35 -7.05,8.08 -8.32,14.89 -5.35,7.52 -11.96,9.45 -18.73,9.93 -9.01,0.67 -18.62,-5.33 -21.11,-12.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1318.01 1019.33c-9.04,5.62 -16.88,8.52 -25.03,1.98 -7.41,-6.03 -15.63,-11.37 -14.59,-22.85 0.37,-3.87 0.47,-8.43 4.62,-9.4 10.32,-2.53 20.85,-3.67 30.11,3.39 8.81,6.73 10.44,15.46 4.89,26.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2200.88 181.12c-7.39,2.08 -12.86,-0.49 -16.19,-7.63 -5.29,-11.45 -7.76,-23.45 -7.27,-38.15 3.35,-8.88 8.46,-9.72 13.84,-5.35 10.04,8 15.65,19.12 20.11,30.86 0.67,1.7 0.6,3.75 0.73,5.64 0.25,6.82 -4.27,12.71 -11.22,14.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M3154.05 1022.09c2.7,-12.45 9.3,-20.97 23.81,-24.33 7.35,1.11 9.33,5.52 11.28,10.03 5.24,12.29 4.37,21.87 -3.29,29.21 -6.53,6.28 -14.57,3.71 -21.93,2.45 -8.95,-1.52 -11.89,-7.83 -9.87,-17.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1281.96 2391.56c-1.44,-0.8 -2.67,-2.85 -3.2,-4.55 -3.03,-10.02 2.08,-25.79 8.96,-28.33 10.93,-4.07 25.49,4.09 29.13,16.97 0.92,3.31 -0.94,7.4 -2.58,12.86 -10.92,13.17 -21.64,9.07 -32.31,3.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2421.4 298.33c-2.23,-15.28 -4.56,-30.92 6.71,-44.12 1.57,-1.79 5.22,-3.5 7.18,-2.93 2.22,0.6 4.39,3.65 5.31,6.12 0.95,2.55 0.36,5.7 0.42,10.77 2.72,12.18 10.31,21.21 6.86,32.52 -0.74,2.5 -2.53,5.56 -4.68,6.58 -7.14,3.36 -20.85,-2.06 -21.79,-8.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2466.91 1279.97c0.12,-0.21 0.22,-0.4 0.33,-0.59 -0.74,0.14 -1.57,0.31 -2.42,0.5 -1.38,-5.18 -1.86,-8.86 -3.2,-14.78 -0.15,0.43 -0.24,0.86 -0.41,1.23 -3.94,-5.51 -6.32,-10.29 -0.4,-12.07 0.22,-1 0.55,-2 0.93,-2.98 0.09,0.02 0.08,-0.06 1.48,0.32 -0.22,-0.67 -0.42,-1.35 -0.57,-2.04 11.6,-2.1 13.11,-12.97 19.5,-18.27 3.89,-3.29 8,-5.81 12.9,-3.15 4.8,2.63 11.38,3.97 12.39,10.74 0.89,6.44 -3.36,10.41 -7.92,14.24 -4.95,4.2 -13.59,0.59 -16.86,7.88 1.95,6.81 3.94,13.08 5.59,19.5 0.8,3.17 -0.82,6.01 -3.65,6.91 -7.5,2.35 -15.05,3.97 -17.69,-7.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1937.47 265.84c-1.26,12.47 -7.71,17.31 -17.34,17.41 -7.98,0.11 -10.85,-6.63 -14.15,-12.48 -4.37,-7.83 -4.83,-16.37 -4.85,-25.01 -0.07,-5.09 2.53,-9.04 7.25,-11.33 5.06,-2.44 9.16,0.11 13.16,2.83 9.36,6.34 12.85,16.23 15.92,28.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2457.09 1388.89c5.31,-8.12 15.55,-10.16 25.37,-4.8 2.5,1.33 4.42,3.74 8,7.1 4.25,7.01 4.25,12.62 1.37,18.14 -5,9.77 -17.35,13.2 -27.56,7.93 -7.88,-4.1 -12.18,-20.88 -7.19,-28.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2962.21 28.39c-2.28,-15.38 3.89,-26.95 13.16,-28.31 6.07,-0.93 14.49,6.54 17.84,16.37 2.16,6.32 3.85,12.75 1.95,19.7 -2.96,10.69 -13.64,14.83 -22.43,8.26 -4.79,-3.62 -7.41,-8.72 -10.51,-16.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M3200.55 415.81c-4.65,-10.85 -1.97,-20.77 7.34,-28.04 6.54,-5.19 15.45,-3.49 20.13,3.45 5.23,7.82 5.86,16.54 3.21,24.9 -2.55,7.91 -9.16,12.1 -19.85,11.12 -6.61,-2.83 -9.07,-7.01 -10.82,-11.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1060.17 1654.17c10.99,-7.63 27.83,-3.96 34.74,8.11 3.18,5.45 2.59,11.31 -3.09,15.14 -3.13,2.05 -6.91,3.08 -12.34,4.71 -9.94,-0.79 -16.03,-5.52 -21.65,-10.68 -5.11,-4.69 -3.7,-13.07 2.36,-17.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1747.06 1927.84c5.09,8.76 -1.18,20.45 -11.28,21.51 -6.91,0.72 -13.34,-0.95 -19.77,-3.13 -5.34,-1.77 -9.12,1.6 -11.9,0.71 2.61,-13.93 2.88,-24.37 15.84,-28.55 10.73,-3.51 21.2,-0.7 27.11,9.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1673.4 1459.1c2.25,4.71 1.86,11.98 -2.15,12.8 -13.12,2.71 -10.54,16.87 -20.55,23.66 -5.71,1.22 -9.6,2.29 -13.28,1.59 -7.89,-1.29 -10.52,-7.51 -11,-14.69 -0.35,-4.79 0.05,-11.76 4.8,-12.37 9.99,-1.27 18.2,-1.92 14.49,-15.43 -0.32,-0.99 1.84,-3.27 3.29,-3.99 9.22,-4.36 19.94,-0.62 24.4,8.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1682.73 1324.14c5.41,-4.12 11.75,-3.75 18.44,1.76 3.7,3.03 7.31,6.49 9.92,10.44 8.35,12.61 1.96,25.01 -13.52,26.4 -2.75,0.24 -5.61,-1.18 -10.18,-2.84 -4.61,-6 -7.95,-10.81 -10.42,-15.98 -3.88,-8.72 -2.17,-13.86 5.75,-19.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1535.77 1413.57c8.17,1.73 11.82,6.05 14.31,11.52 7.97,17.19 0.85,22.3 -15.76,24 -6.33,0.64 -10.95,-3.09 -15.38,-6.77 -11.38,-9.39 -9.92,-20.13 3.61,-25.89 3.51,-1.45 7.37,-2.05 13.22,-2.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2538.76 1379.74c1.65,-2.31 2.8,-5.01 4.7,-7.06 1.17,-1.26 3.26,-2.3 4.99,-2.3 7.65,-0.05 20.54,13.95 19.13,21.86 -1.55,8.78 -1.41,18.67 -8.59,25.86 -5.29,-3.27 -9.34,-5.79 -14.9,-9.54 -14.87,-15.29 -14.87,-15.29 -5.33,-28.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2485.33 1640.68c1.28,-5.66 6.22,-8.31 10.89,-7.67 7.54,1.02 14.8,3.93 23.92,6.33 3.47,0.23 6.49,-0.33 6.9,0.38 6.22,11.51 4.24,16.2 -7.5,18.13 -10.52,1.77 -21.16,4.25 -30.38,-3.96 -4.03,-3.65 -4.85,-8.25 -3.83,-13.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2336.21 651.52c3.49,3.01 6.67,7.09 8.4,11.3 4.25,10.53 0.68,22.6 -7.24,24.83 -10.92,2.99 -15.61,-4.25 -19.27,-14.82 -0.49,-5.7 -1.46,-9.64 -0.84,-13.31 1.78,-10.29 11.51,-14.46 18.95,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2369.47 1710.77c-0.07,-3.66 -1.11,-6.8 -0.49,-7.28 9.14,-5.79 18.91,-6.61 29.03,-2.62 7.96,3.1 11.29,10.32 8.45,18.35 -4.03,11.47 -14.52,16.27 -25.06,10.97 -6.91,-3.55 -12.68,-8.54 -11.93,-19.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1367.23 1180.99c3.76,4.41 6.38,7.3 7.88,10.69 4.1,8.67 0.61,15.43 -7.99,16.61 -6.84,0.99 -13.54,0.01 -18.55,-4.83 -5.98,-5.87 -13.06,-11.74 -10.34,-21.81 1.75,-6.41 8.45,-7.76 22.46,-4.61 1.81,0.35 3.38,1.74 6.54,3.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2249.85 1132.8c-5,-2.01 -8.04,-2.68 -10.23,-4.28 -9.96,-7.67 -12.46,-20.32 -6.3,-30.34 3.37,-5.52 10.93,-4.65 23.29,2.68 8.45,4.95 11.08,13.09 6.08,21.91 -2.27,4.02 -6.38,7.09 -9.39,10.62 0.24,-0.01 -1.13,0.29 -3.45,-0.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1559.34 525.95c-11.12,18.48 -16.71,19.11 -26.96,4.94 -1.66,-2.31 -3.27,-4.75 -4.63,-7.3 -4.82,-9.15 -5.11,-19.7 -0.45,-21.21 7.96,-2.69 15.26,0 21.56,4.89 5.53,4.24 9.48,9.66 10.49,18.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1128.18 942.52c0.33,-3.74 1.85,-7.44 3.88,-12.75 10.26,-7.87 19.34,-5.8 28.04,-0.76 5.98,3.44 8.1,10.58 5.92,17.53 -2.03,6.67 -6.86,8.73 -13.22,8.18 -5.79,-0.44 -11.6,-0.49 -17.2,-1.49 -5.43,-1.07 -7.78,-5.54 -7.42,-10.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1658.82 1959.76c8.17,-9.03 17.78,-10.67 28.19,-4.73 7.39,4.19 10.29,12.16 7.3,22.12 -1.04,3.6 -3.39,6.84 -7.55,9.59 -7.95,0.59 -13.57,1.77 -19.23,2.84 -4.01,0.71 -7.27,-0.38 -9.81,-3.92 -6.51,-9.15 -6.22,-17.7 1.1,-25.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1502.1 876.28c-10.18,3.73 -16.3,-1.35 -22,-6.13 -8.22,-6.95 -10.16,-16.84 -5.33,-22.47 4.28,-5.04 11.76,-5.02 20.86,0.07 12.16,6.77 13.87,12.6 6.47,28.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2454.32 785.09c-5.61,6.47 -11.67,11.78 -14.3,20.88 -2.66,9.34 -10.3,10.17 -18.12,3.78 -4,-3.18 -6.45,-7.13 -5.43,-14.23 6.39,-11.65 19.42,-15.51 21.48,-28.6 0.55,-3.82 6.28,-3.84 10.06,-2.48 9.63,3.49 12.87,13.06 6.32,20.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2894.05 2535.08c1.19,-7.05 6.66,-11.43 14.09,-11.3 13.63,0.28 18.05,7.55 14.53,27.22 -7.18,6.03 -13.7,5.37 -20.18,3.05 -7.04,-2.58 -9.95,-9.57 -8.44,-18.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M631.6 1913.42c0.29,1.77 0.21,4.08 -0.69,5.55 -5.14,8.19 -12.69,11.05 -23.88,8.84 -5.24,-3.91 -9.07,-6.83 -11.86,-10.57 -4.95,-6.32 -2.49,-13.33 5,-15.23 2.74,-0.68 5.58,-1.44 8.38,-1.43 12.25,-0.14 21.49,5.05 23.06,12.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1888.41 1702.04c7.68,0.93 15.09,2.81 18.4,11.24 2.77,7.16 -0.71,14.2 -11.02,20.62 -2.18,1.35 -5.52,0.81 -10.32,0.51 -7.79,-3.37 -9.43,-9.03 -11.18,-14.43 -3.47,-11.04 2.9,-19.27 14.11,-17.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2568.78 1886.93c-8.21,8.1 -10.33,23.61 -28.22,21.99 -4.48,-3.06 -8.03,-5.29 -9.65,-8.57 -3.68,-7.42 -0.39,-17.62 6.25,-19.51 9.24,-2.62 18.82,-3.12 28.23,-0.61 2.83,0.77 5.22,4.85 3.38,6.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2159.77 633.11c9.82,-0.58 10.72,5.77 10.94,13.23 0.34,12.09 -1.65,17.09 -8.84,18.92 -2.62,0.69 -5.82,0.66 -8.36,-0.26 -7.31,-2.56 -9.47,-9.23 -10.86,-15.97 -1.47,-7.17 -0.71,-13.63 9.43,-16.59 3.86,0.24 5.84,0.8 7.7,0.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2039.59 1876.85c-5.25,-4.05 -9.4,-6.95 -11.74,-10.93 -4.02,-6.87 -2.09,-13.31 4.07,-17.63 8.84,-6.18 21.29,-2.8 27.25,7.38 4.15,7 0.41,16.12 -9.11,20.97 -2.41,1.28 -5.65,0.66 -10.47,0.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2020.14 1446.36c3.03,-14.77 15.9,-19.64 27.56,-10.19 2.8,2.25 4.35,6.04 6.76,11.08 -0.38,12.53 -6.68,17.01 -16.64,16.99 -9.55,-0.07 -19.27,-10.14 -17.67,-17.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1528.06 1634.17c3.38,-4.14 8.03,-4.7 12.83,-3.59 7.33,1.72 15.12,3.05 18.95,13.89 0.03,0.15 0.07,0.33 0.13,0.45 0.3,-0.48 0.61,-1.01 1.04,-1.48 9.79,7.57 18.92,0.79 27.28,4.14 7.64,3.15 10.75,12.22 5.23,18.77 -4.94,5.94 -11.56,7.17 -18.08,3.5 -5.94,-3.38 -8.82,-11.95 -16.98,-12.8 -0.83,1.08 -1.87,2.15 -3.27,3.15 -12.85,6.33 -21.54,2.06 -28.39,-7.39 -3.6,-4.88 -2.9,-13.55 1.27,-18.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2285.96 782.95c4.97,-3.64 12.66,-1.27 15.91,6.9 3.09,7.85 6.52,14.6 12.74,19.02 1.31,0.21 2.72,0.5 4.21,0.86 4.04,6.25 6.56,11.52 9.98,18.31l0.06 0.04c0.15,-0.38 0.2,-0.77 0.43,-1.17 3.75,3.51 5.98,6.84 3.65,10 0.3,1.37 0.57,2.87 0.73,4.61 1.14,9.68 -1.58,15.46 -8.14,19.11 -4.22,2.34 -8.75,3.82 -13.81,2.96 -12.23,-2.08 -19.23,-11.23 -18.13,-25.1 0.35,-4.67 2.6,-9.2 4.11,-15.96 0.02,-0.15 0.04,-0.25 0.09,-0.37 -0.26,0.09 -0.44,0.26 -0.7,0.35 -0.86,-12.16 -11.97,-10.67 -16.14,-17.04 -4.52,-7.02 -2.96,-16.69 5.02,-22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2133.7 1508.75c-9.66,12.4 -28.92,10.34 -35.32,-3.81 -2.61,-5.68 -0.4,-11.28 2.5,-17.67 8.04,-5.01 14.02,-7.28 21.21,-5.76 10.76,2.21 18.01,19.08 11.62,27.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2929.55 206.37c3.25,-6.74 7.04,-13.4 13.69,-17.68 3.07,-2.01 5.72,-0.33 6.62,2.32 1.5,4.42 2.16,9.12 3.44,15.72 0.34,3.86 0.86,5.89 0.39,7.64 -3.15,10.71 -7.62,14.29 -15.05,12.33 -8.55,-2.23 -13.17,-11.84 -9.09,-20.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2960.79 846.39c-3.14,2.82 -6.94,2.62 -10.6,0.35 -4.31,-2.65 -6.81,-6.64 -8.6,-13.3 2.38,-6.05 4.41,-10.53 7.53,-13.98 5.73,-6.11 14.51,-8.78 17.72,-5.87 5.85,5.3 4.01,12.45 3.49,18.9 -0.5,6.05 -5.26,10.13 -9.55,13.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1970.22 965.76l-0.04 0.04 -0.08 -0.03c0.02,0 0.08,-0.01 0.12,-0.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1970.1 965.77c-0.04,0.02 -0.07,-0 0,0l0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2263.54 1565.49c-2.64,8.87 -7.33,13.19 -14.1,15.41 -6.31,2.1 -11.02,0.23 -13.76,-6.08 -1.46,-3.46 -2.94,-7.02 -3.58,-10.73 -1.04,-5.99 0.44,-11.38 6.03,-14.81 6.09,-3.76 12.53,-4.9 18.69,-0.56 4.92,3.43 7.63,8.37 6.72,16.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2332.1 96.19c2.01,-7.21 9.33,-10.7 15.4,-7.78 7.73,3.69 10.67,10.47 11.94,18.06 1.06,6.25 -2.22,10.82 -9.57,14.06 -17.3,-7.54 -20.86,-13.12 -17.77,-24.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M692.94 3017.62c-0.39,-2.21 1.24,-5.8 3.12,-7.37 5.75,-4.88 11.93,-9.47 18.36,-13.39 5.17,-3.09 11.21,-3.53 15.64,1.55 5.48,6.21 4.31,12.12 -3.92,18.12 -8.5,5.66 -16.54,3.3 -23.97,4.91 -3.64,0.79 -8.23,1.05 -9.23,-3.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1957.09 1094.13c-0.59,-10.71 6.89,-15.82 16.28,-11.96 4.63,1.93 7.74,5.15 10.41,9.16 4.62,7.05 3.21,11.48 -4.73,19.37 -7.28,7.18 -11.53,1.95 -17.48,-4.38 -2.41,-5.07 -4.31,-8.59 -4.49,-12.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2691.66 745.46c-2.39,-9.9 -2.92,-17.7 6.46,-21.41 7.91,-3.1 17.1,0.32 20.11,7.02 3.38,7.47 0.5,19.7 -6.1,23.56 -2.29,1.3 -5.66,1.32 -8.39,1.08 -5.26,-0.5 -8.43,-4.38 -12.08,-10.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2243.25 644.14c-6.12,1.99 -11.59,0.06 -15.31,-4.94 -7.36,-9.88 -6.57,-17.44 4.36,-30.81 12.13,3.6 16.7,11.68 18.71,21.67 1.09,5.57 -2.66,12.45 -7.77,14.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2470.31 1481.64c6.83,-0.96 13.08,5.27 13.68,11.72 0.49,5.74 -4.73,13.77 -10.54,15.12 -6.01,1.39 -10.93,-0.63 -14.85,-5.77 -3.81,-4.94 -4.07,-10.33 -3.91,-16.05 0.03,-0.89 -0.14,-1.56 -0.42,-2.09 5.75,-0.2 10.82,-2.24 16.04,-2.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2454.27 1484.56c-1.23,0.02 -2.53,0.01 -3.84,-0.16 1.08,-1.52 3.02,-1.53 3.84,0.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2590.42 1509.5c-2.1,6.03 -6.81,9.25 -12.99,9.57 -7.6,0.35 -12.55,-4.02 -15.41,-10.67 -2.87,-6.62 1.64,-10.68 7.21,-15.91 4.98,-3.14 8.94,-3.78 12.41,-2 7.71,4.1 11.25,11.99 8.78,19.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M3003.76 1340.03c0.47,-3.55 2.83,-6.86 6.12,-11.29 6.53,-1.18 11.31,-1.93 15.93,-1.27 2.37,0.33 5.44,2.63 6.53,4.88 3.25,6.71 0.84,13.21 -2.67,19.05 -2.44,4.01 -12.43,5.3 -18.77,2.79 -6.37,-2.58 -7.94,-8.18 -7.15,-14.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2602.24 902.26c-7.5,4.92 -9.93,-1.46 -12.08,-9.38 -2.89,-9.82 -9.87,-9.96 -16.8,-11.39 5.62,-4.42 10.79,-8.57 16.03,-12.56 3.37,-2.57 7.25,-2.9 10.89,-0.9 15.14,8.25 16.36,24.81 1.95,34.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M3034.69 636.26c2.53,-8.86 14.58,-16.4 22.31,-15.13 4.29,0.7 6.64,4.08 6.63,8.35 -0.07,10.4 -3.43,18.95 -15.82,23.14 -11.11,-1.48 -15.65,-7.38 -13.12,-16.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1809.42 1591.08c-6.01,4.36 -15.71,1.31 -22.29,-7.07 -6.19,-7.79 -2.67,-16.3 7.96,-18.76 2.68,-0.63 5.74,0.09 10.36,0.91 10.68,13.73 11.17,19.67 3.97,24.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M649.39 945.34c2.84,9.71 -3.56,14.07 -14.11,16.09 -11.05,-1.59 -15.09,-7.98 -16.41,-16.1 -0.81,-5.02 1.22,-9.82 6.7,-11.4 9.47,-2.76 21.24,2.51 23.82,11.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2349.67 1367.87c-6.73,-3.78 -12.82,-4.31 -19.03,-1.52 -0.53,1.34 -1.38,2.79 -2.79,4.41 -6.82,6.49 -12.4,11.54 -18.52,15.9 -22.35,15.91 -20.68,11.22 -36.18,-5.51 -4.05,-4.39 -8.24,-10.45 -7.52,-19.49 0,-0.18 -0.02,-0.33 -0.02,-0.49 -0.29,0.05 -0.52,0.14 -0.83,0.16 -2.77,-7.84 -4.78,-13.28 -12.32,-12.99 -4.74,0.17 -9.57,1.23 -14.13,0.5 -4.8,-0.76 -7.43,-10.03 -4.87,-14.76 2.4,-4.35 6.1,-3.78 10.02,-3.1 10.64,1.73 16.65,10.96 25.71,17.47 0.6,-0.6 1.28,-1.21 2.08,-1.81 3.45,-1.52 5.51,-2.11 10.08,-3.42 0.42,-0.2 0.83,-0.34 1.22,-0.5 -0.9,-0.22 -1.77,-0.47 -2.65,-0.79 7.62,-6.66 10.27,-11.91 9.49,-20.96 -1.03,-10.98 6.34,-14.74 16.72,-11.02 7.95,2.85 10.23,7.7 6.81,15.26 -1.15,2.51 -2.52,5.19 -4.58,6.93 -4.78,4.06 -4.1,7.49 -2.76,10.65 2.15,1.6 4.15,3.84 6.06,6.86 4.84,1.79 8.02,3.16 13.13,5.12 0.04,0.04 0.07,0.08 0.11,0.1 -0.01,-0.41 -0.07,-0.8 -0.06,-1.21 11.29,3.8 15.19,-5.41 21.63,-8.26 5.8,-2.55 11.71,-0.52 15.5,3.99 3.9,4.65 4.18,10.59 0.4,15.8 -3.21,4.42 -8.35,5.18 -12.69,2.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2746.58 992.62c3.98,-7.01 10.42,-12.64 16.17,-18.51 0.95,-0.97 3.62,-0.92 5.32,-0.57 6.2,1.36 10.47,5.46 10.73,11.58 0.32,6.15 -3.2,10.97 -9.96,11.59 -3.64,0.32 -7.49,-0.64 -13.06,-0.59 -6.11,2.01 -11.16,-0.12 -9.2,-3.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1580.04 747c1.52,-2.59 2.88,-3.75 6.44,-5.63 -0.64,-0.18 -1.21,-0.33 -1.79,-0.58 5.3,-7.79 9.65,-5.82 11.87,-0.97 1.63,0.14 3.29,0.4 5.22,0.79 14.7,2.78 21.3,10.28 20.26,25.29 -0.02,0.05 -0.03,0.09 -0.05,0.14 0.26,-0.24 0.5,-0.5 0.78,-0.67 1.25,5.69 0.05,9.2 -4.54,8.86 -0.83,0.86 -1.73,1.71 -2.83,2.62 -5.78,2.95 -9.92,5.82 -16.69,2.22 -0.03,-0.09 -0.07,-0.18 -0.12,-0.28 -0.01,0.46 0.03,0.9 -0.02,1.34 -12.15,-4.32 -16.77,-14.11 -22.61,-22.42 -2.07,-3.08 -0.49,-6.86 3.89,-7.67 -0.01,-0.97 0.05,-1.98 0.2,-3.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M774.56 672.76c6.71,-2.82 13.43,-1.63 18.23,4.04 3.8,4.44 6.43,10.08 3.36,15.82 -3.22,6.05 -9.33,5.67 -15.14,4.74 -1.82,-0.26 -3.47,-1.44 -6.37,-3.58 -3.99,-5.43 -6.04,-9.9 -4.88,-14.74 0.57,-2.43 2.66,-5.37 4.81,-6.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2543.47 1105.04c-0.63,1.37 -1.38,2.79 -2.49,4.28 -4.39,10.61 -10.81,14.33 -21.72,13.23 0.33,0.5 0.68,0.98 1.04,1.51 -0.2,8.42 2.01,16.59 -7.81,17.66 -5.69,0.58 -8.76,2.25 -8.82,8.28 -0.05,3.84 -0.72,7.53 -4.24,10.13 -2.51,1.89 -8.67,1.21 -10.3,-1.37 -4.51,-7.25 -2.39,-14.91 -1.28,-22.35 0.75,-5.56 5.52,-7.34 10.43,-8.23 7.44,-1.3 9.1,-6.79 11.6,-11.96 -0.57,-1.4 -0.96,-3.12 -1.12,-5.22 -3.17,-24.41 -0.04,-28.14 20.74,-27.09 1.72,0.09 3.47,0.89 6.62,2.24 -0.14,-0.86 -0.33,-1.68 -0.48,-2.58 3.57,-5.69 5.93,-10.15 9.45,-13.16 8.17,-6.77 16.43,-3.89 20.08,6.18 2.55,7.21 1.19,13.2 -4.01,18.55 -4.91,5.08 -10.94,8.38 -17.69,9.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2098.09 398.93c-5.69,-0.07 -8.25,-4.17 -10.39,-8.65 -4.08,-8.68 -3.35,-10.58 9.59,-21.12 5.64,2.77 9.67,5.43 12.99,8.71 3.69,3.67 4.81,8.45 2.26,13.24 -3.02,5.59 -8.23,7.94 -14.45,7.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2752.83 1204.99c-6.47,-1.56 -11.53,-2.87 -12.55,-8.52 -1.02,-5.63 -1.72,-11.67 2.18,-16.65 3.29,-4.14 8.09,-5.51 12.95,-3.37 7.08,3.08 8.98,9.58 9.19,16.65 0.2,6.9 -3.4,10.67 -11.77,11.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2420.59 1652.81c-4.94,-1.64 -7.38,-5.86 -8.55,-10.47 -1.32,-5.29 1.53,-9.6 6.16,-11.29 5.19,-1.94 10.89,-2.33 18.06,-4.21 4.66,-2.23 8.76,-0.64 7.97,1.37 -2.78,7.67 -6.25,15.28 -10.7,22.13 -2.76,4.25 -8.23,4.08 -12.95,2.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M854.39 1672.58c-0.72,7.25 -6.38,8.89 -12.4,9.19 -4.73,0.25 -9.51,-0.06 -14.78,-4.52 -4.63,-7.47 -3.26,-12.36 2.42,-16.04 4.94,-3.21 10.11,-5.31 16,-2.01 5.22,3.03 9.39,6.89 8.76,13.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1321.31 1114c-1.69,3.14 -4.48,6.59 -7.61,7.98 -5.55,2.53 -11.34,1.23 -15.74,-3.46 -5.85,-6.23 -8.64,-12.85 0.11,-20.89 8.98,-1.43 14.83,1.97 20.16,6.22 3.22,2.56 5.03,6.41 3.08,10.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2781.55 2475.36c-3.99,-7.8 1.68,-12.5 6.88,-16.95 0.7,-0.65 1.57,-1.15 4.08,-2.38 10.95,-1.03 16.53,2.65 16.63,12.57 0.03,6.78 -3.73,10.83 -9.69,12.78 -6.14,1.97 -15.28,-0.86 -17.89,-6.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M3089.13 792.44c0.24,-4.75 2.22,-9.34 4.38,-15.54 12.08,-5.85 16.92,-4.81 18.99,2.47 1.97,6.86 2.11,13.53 -2.71,19.31 -3.3,4.04 -7.73,5.89 -12.89,4.61 -5.55,-1.37 -8,-5.86 -7.77,-10.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M3151.64 1548.09c0.29,-10.16 4.66,-13.68 16.69,-14.49 5.09,-0.35 9.68,0.43 11.3,5.91 2.62,8.8 -1.44,16.33 -10.77,19.7 -2.48,0.87 -5.57,-0.05 -10.14,-0.96 -5.28,-2.89 -7.18,-6.26 -7.07,-10.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1088.43 1146.11c1.07,2.35 1.38,5.82 0.47,8.14 -1.58,4.04 -5.91,4.37 -9.63,4.01 -10.14,-1.04 -17.66,-6.63 -18.11,-14.71 -0.36,-7.21 2.93,-12.8 13.3,-12.91 8.69,3.18 11.22,9.53 13.96,15.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1917.36 2517.89c3.74,4.32 8.75,1.92 13.19,2.59 11.32,1.78 13.51,5.95 9.61,18.26 -0.52,1.71 -2.31,3.03 -5.39,5.6 -19.94,-1.58 -21.39,-3.02 -19.3,-16.72 0.51,-3.24 1.24,-6.48 1.9,-9.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2039.99 1714.99c6.15,-6.4 11.46,-5.89 16.87,-2.94 4.25,2.33 7.63,5.34 9.21,10.25 2.21,6.76 -1.29,13.56 -8.29,15.53 -13.86,3.74 -20.67,-3.8 -17.8,-22.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1581.32 2031.38c0.01,3.82 0.79,7.84 0.14,11.55 -0.43,2.45 -2.34,5.93 -4.35,6.52 -1.94,0.59 -7.06,-1.9 -6.99,-2.95 0.34,-11.27 -11.26,-15.39 -13.33,-26.44 19.95,-8.44 24.55,-5.82 24.53,11.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1890.89 1853.85c-6.36,-0.82 -11.07,-4.6 -12.37,-10.65 -1.51,-6.96 4.11,-10.17 9.46,-12.75 1.69,-0.79 3.79,-0.69 7.55,-1.07 10.1,1.35 13.68,6.34 11.22,14.41 -2.15,6.98 -8.86,10.89 -15.86,10.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2150.12 1224.45c2.12,-2.71 3.73,-7.1 8.82,-6.89 5.76,5.96 10.79,12.51 11.44,23.31 0.62,-0.44 1.31,-0.91 2.06,-1.35 30.6,-1.14 34.34,1.47 43.08,28.11 0.57,1.8 1.02,3.65 0.93,7.62 -7.95,16.46 -19.52,20.59 -34.42,15.59 -6.6,-2.2 -11.21,-7.29 -14.92,-13.19 -3.88,-6.11 -4.41,-12.42 -2.11,-21.06 -0.35,0.14 -0.63,0.33 -1,0.43 -5.08,-4.37 -9.06,-7.21 -12.61,-10.39 -8.77,-8.06 -9.18,-12.21 -1.27,-22.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2712.83 1047.26c-5.95,1.04 -11.19,-5.06 -12.93,-15.85 -0.43,-2.62 0.86,-5.55 2.56,-9.95 4.94,-5.57 9.09,-6.32 13.88,-3.44 3.39,2.01 6.18,4.44 7.08,8.43 1.99,8.97 -3.43,19.5 -10.59,20.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1227.1 720.62c2.01,3.04 3.18,7.06 3.39,10.67 0.19,4.04 -2.58,7 -8.54,8.64 -13.27,-1.28 -18.82,-7.94 -19.32,-19.1 -0.22,-4.57 2.46,-7.51 6.66,-7.66 6.88,-0.25 13.66,1.37 17.81,7.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2750.2 1699.31c-1.44,-7.45 -2.39,-15.01 6.13,-20.72 8.45,2.51 13,6.92 15.13,13.86 2.16,7.35 -1.68,14.56 -8.32,15.52 -5.7,0.84 -11.82,-2.9 -12.94,-8.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M537.05 1798.26c4.52,-0.45 9.26,1.34 15.63,2.83 6.81,9.39 6.57,13.98 1.03,16.38 -5.34,2.44 -10.91,3.5 -16.61,2.09 -4.69,-1.12 -9.29,-3.3 -9.39,-9.07 -0.02,-6.27 2.73,-11.53 9.34,-12.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2448.38 1482.43c0.02,-0.16 0.07,-0.31 0.11,-0.46 0.14,0.07 -0.07,0.35 -0.11,0.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2447.15 1482.39c-7.73,3.72 -13.34,3.75 -18.22,-0.59 -7.23,-6.39 -6.56,-16.78 1.14,-22.55 5.4,-4.03 12.21,-2.09 17.66,4.28 5.46,6.35 2.28,12.42 0.76,18.43 -0.11,-0.03 -0.42,0.02 -1.34,0.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1642.68 1669.44c4.69,-4.91 10.85,-7.67 17.81,-6.21 6.13,1.3 9.69,5.39 10.03,13.69 -2.55,9.06 -7.22,13.95 -14.74,12.44 -6.38,-1.22 -12.57,-4.82 -14.3,-12.14 -0.58,-2.43 -0.35,-6.17 1.2,-7.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1554.96 1029.74c-3.56,2.27 -7.37,1.38 -12.94,-0.94 -7.01,-3.41 -12.37,-5.64 -17.32,-8.46 -2.94,-1.59 -2.81,-4.87 -1.83,-7.63 0.6,-1.63 2.24,-4.19 3.4,-4.2 11.3,-0.13 22.77,0.02 31.5,8.91 3.37,3.44 1.96,9.31 -2.81,12.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2682.13 1165.92c-3.08,-4.57 -1.8,-8.93 0.42,-13.35 2.27,-4.36 5.44,-7.67 12.08,-8.8 10.34,4.19 10.77,11.87 10.1,19.56 -0.19,2.22 -2.59,5.09 -4.74,6.15 -6.16,3.16 -14.76,1.08 -17.85,-3.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1967.3 596.19c1.34,4.08 -3.24,6.4 -9.21,7.15 -13.71,-9.27 -10.74,-23.17 -14.02,-34.87 -0.78,-2.84 0.61,-6.13 3.86,-6.43 2.5,-0.23 6.12,0.55 7.65,2.29 7.88,9.02 8.19,21.1 11.71,31.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1796.13 2501.74c-1.66,-7.72 3.19,-12.38 8.79,-16.28 4.4,-3.04 8.84,-2.57 13.03,0.62 6.09,4.63 8.23,10.14 1.95,18.34 -5.17,4.11 -9.16,6.83 -14.19,6.28 -5.3,-0.5 -8.53,-3.99 -9.59,-8.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2610.06 786.99c-6.3,-0.44 -10.63,-3.89 -11.24,-10.47 -0.55,-6.17 -4.3,-13.23 3.46,-17.71 1.49,-0.84 3.69,-1.17 5.39,-0.9 4.8,0.8 8.66,3.31 11.18,9.84 0.23,4.66 0.35,7.53 -0.19,10.19 -0.99,4.66 -2.53,9.55 -8.61,9.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2330.81 620.59c-2.92,-2.14 -4.74,-5.77 -8.09,-10.62 -3.44,-9.2 -15.78,-15.99 -5.6,-23.75 7.36,-5.64 13.11,4.97 19.31,8.38 7.92,4.32 9.47,13.44 6.17,22.39 -1.5,4.05 -7.91,6.46 -11.79,3.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2813.47 1892.3c-6.69,3.33 -12.89,2.96 -16.58,-6.92 -1.07,-6.72 0.04,-11.15 4.66,-13.85 6.67,-3.87 13.76,-2.16 17.13,3.89 3.33,6.05 1.37,13.66 -5.21,16.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2416.07 1346.13c-6.78,2.84 -10.17,-2.36 -13.69,-6.84 -3.02,-3.81 -5.31,-8 -3.45,-12.99 1.87,-5.02 5.8,-7.19 12.84,-6.79 4.66,2.64 8.53,4.47 10.14,7.48 3.98,7.45 1.22,16.12 -5.84,19.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1999.99 310.72c0.83,-3.89 4.38,-6.24 8.72,-4.62 4.43,1.68 8.89,3.42 12.79,5.98 7.2,4.74 6.29,14.11 -1.85,18.14 -6.75,3.36 -13.83,5.99 -22.6,7.06 -4.05,-10.79 1.23,-18.37 2.94,-26.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M212.27 1210.59c0.99,10.5 -4.73,12.85 -12.24,11.96 -6.91,-0.81 -12.9,-3.6 -14.4,-11.35 -0.82,-4.51 2.33,-6.97 5.94,-8.51 8.31,-3.51 14.47,0.33 20.7,7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2826.3 663.69c0.49,-5.16 3.09,-8.81 10.1,-11.22 4.87,0.49 7.89,0.84 10.23,2.31 6.27,3.98 9.1,9.64 6.02,16.98 -3.14,7.49 -11.34,11.11 -18.75,8.56 -5.72,-1.98 -8.4,-7.79 -7.6,-16.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2559.44 89.97c0.78,-5.62 1.71,-11.57 6.61,-15.37 1.11,-0.87 4.16,-0.89 5.18,-0.02 5.84,5.24 9.66,11.87 9.67,19.85 -0.02,5.34 -4.16,8.31 -10.45,11.31 -9.15,-2.73 -12.04,-8.38 -11.01,-15.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2112.24 2457.88c1.04,-1.44 3.08,-2.13 6.35,-3.54 2.68,-0.21 3.83,-0.26 4.51,0.23 7.97,6.91 10.12,13.38 6.18,18.51 -3.85,4.96 -12.64,7.05 -17.9,4.18 -5.72,-3.06 -5.52,-10.4 0.86,-19.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2504.67 1703.13c-4.83,-1.91 -7.52,-5.61 -7.51,-12.9 1.99,-4.36 3.06,-7.49 5.27,-8.87 6.83,-4.43 14.12,-3.86 17.88,1.16 3.66,4.84 4.68,10.46 1.89,16.12 -2.81,5.77 -9.92,7.52 -17.52,4.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2848.65 1202.35c-4.12,2.81 -9.14,4.36 -13.39,1.35 -5.43,-3.8 -4.74,-9.89 -3.38,-15.57 1.22,-5.13 4.68,-8.12 11.46,-9.35 4.4,3.04 7.6,5.42 9.26,8.64 2.99,5.78 1.42,11.19 -3.95,14.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1878.45 756.56c-2.22,-1.76 -4.32,-3.81 -6.09,-6.06 -3.64,-4.55 -2.87,-11.1 1.51,-15.68 4.1,-4.31 10.54,-4.87 15.28,-0.25 3.32,3.27 5.52,7.72 8.36,13.6 -7.72,13.66 -11.07,14.85 -19.07,8.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M833.93 889.28c5.59,-1.14 8.86,2.57 11.22,6.92 2.01,3.7 0.8,7.37 -2.62,12.15 -3.96,2.29 -6.62,3.95 -9.27,3.96 -5.26,0.04 -9.07,-3.01 -10.11,-8.31 -1.25,-6.08 4.12,-13.39 10.78,-14.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2449 469.21c4.08,4.82 5.25,10.21 0.87,15.31 -4.2,4.87 -12.34,5.19 -18.11,0.91 -2.25,-1.66 -4.08,-3.98 -5.67,-6.3 -3.44,-5.02 -2.14,-11.14 3.94,-14.3 2.98,-1.47 7.22,-0.57 12.77,0.02 3.35,2.01 5.02,3.02 6.2,4.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2448.75 622.37c-0.81,-3.46 0.03,-7.32 1.23,-12.53 6.47,-6.42 11.39,-4.33 16.27,-0.64 3.12,2.44 5.63,5.41 4.46,9.52 -1.63,5.72 -5.02,10.65 -11.34,11.18 -4.93,0.4 -9.49,-2.28 -10.62,-7.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1672.39 747.67c-3.05,6.99 -7.53,9.31 -12.19,6.27 -6.34,-4.09 -12.13,-9.27 -17.53,-14.64 -1.48,-1.44 -1.16,-5.26 -0.63,-7.77 0.27,-1.06 3.21,-2.53 4.72,-2.25 6.56,1.17 13.11,2.53 19.45,4.63 5.28,1.75 6.24,6.79 6.19,13.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1746.75 2284.38c2.57,2.93 4.76,6.47 3.34,10.44 -1.86,5.1 -6.68,7.08 -11.42,7.54 -5.18,0.53 -9.01,-2.73 -12.62,-8.6 -0.3,-7.09 3.05,-10.28 7.77,-12.29 4.91,-2.2 9.45,-1.1 12.93,2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2480.85 1598.7c4.03,-3.74 8.33,-4.22 12.42,-0.4 3.84,3.58 4.72,8.42 2.35,12.95 -2.4,4.51 -6.83,6.34 -12.02,4.71 -5.36,-1.69 -10.72,-3.38 -15.91,-5.53 -1.28,-0.57 -1.88,-2.9 -2.82,-4.37 1.62,-0.88 3.15,-1.95 4.86,-2.56 1.74,-0.57 3.67,-0.7 7.23,-1.97 2.43,-1.63 3.19,-2.21 3.9,-2.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2583.69 958c4.24,8.06 2.34,16.72 0.98,26.07 0.79,0.21 1.62,0.46 2.48,0.82 3.42,7.44 2.91,12.88 -4.73,13.28 -5.43,0.27 -7.7,-4.25 -7.09,-9.63 0.17,-1.61 0.68,-3.08 2.07,-4.49 -0.87,-0.46 -1.79,-1 -2.87,-1.73 -9.93,-6.46 -12.99,-13.92 -9.98,-23.4 1.26,-3.8 3.78,-7.32 7.68,-7.92 5.31,-0.83 9.04,2.4 11.47,7.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2736.42 709.96c-9.08,6.34 -13.65,1.96 -16.72,-4.53 -2.9,-6.19 -3.81,-13.04 1.79,-18.21 3.77,-3.52 8.72,-2.72 12.64,0.81 6.57,5.75 7.08,12.7 2.28,21.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1270.33 2182.05c-4.58,-1.84 -8.6,-4.71 -8.54,-9.97 0.04,-5.28 4.44,-7.93 10.51,-10.62 3.7,-0.1 5.83,-0.21 7.22,0.72 7.73,5.23 9.66,10.65 5.76,15.86 -3.82,5.21 -9.03,6.38 -14.95,4.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2884.2 1111.78c1.15,-2.33 3.53,-5.36 5.7,-5.69 5.85,-0.87 11.02,1.84 15.17,6.09 3.77,3.94 4.1,8.23 -0.71,13.82 -6.58,4.3 -11.79,6.54 -16.9,1.38 -4.3,-4.43 -5.96,-9.81 -3.26,-15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2955.09 1023.8c3.38,1.8 5.52,2.78 6.16,4.34 3.89,9.27 1.43,15.61 -6.77,18.45 -6.62,2.24 -12.87,-1.27 -15.88,-8.82 -1.6,-3.95 -1.18,-7.73 1.26,-10.98 3.43,-4.49 8.48,-3.9 15.22,-2.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2496.33 2758.04c0.5,-5.88 5.52,-10.88 11.41,-10.88 4.85,0.03 9.64,1.33 12.14,6.12 2.66,5.21 -1.05,8.91 -5.43,13.95 -4.5,1.15 -7.58,1.93 -10.09,1.16 -4.79,-1.54 -8.51,-4.57 -8.02,-10.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2292.56 193.95c-5.02,3.99 -8.41,3.68 -11.29,0.3 -3.29,-3.88 -4.12,-8.54 -4.22,-13.39 -0.12,-10.4 5.24,-19.56 10.26,-17.63 6.97,2.73 4.9,9.58 6.03,14.72 1.04,4.53 0.37,9.45 -0.79,15.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2702.29 1265.11c-0.44,-9.35 1.78,-15.49 11.14,-13.43 7.36,1.68 10.34,7.88 8.08,15.74 -0.7,2.4 -2.97,5.29 -5.17,6.2 -6.61,2.69 -10.66,-1.3 -14.04,-8.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2018.6 1821.91c-0.83,-2.4 -0.92,-5.86 0.21,-7.98 2.65,-5.03 13.65,-8.32 20.17,-5.71 6.05,2.41 7.56,7.84 4.91,15.83 -4.35,5.23 -7.71,8.77 -12.96,8.05 -6.05,-0.85 -10.32,-4.58 -12.33,-10.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1818.55 2119.56c-0.49,-4.09 1.92,-7.28 6.32,-10.96 5.53,-1.72 9.01,-0.37 12.37,1.76 4.64,2.99 6.61,7.1 4.68,12.25 -1.9,5.12 -6.45,7.16 -11.49,7.11 -6.48,-0.12 -11.03,-3.36 -11.88,-10.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1537.62 1204.14c1.44,7.08 -0.42,11.42 -5.57,13.33 -6.33,2.28 -11.22,-0.76 -15.11,-5.69 -3.3,-4.11 -4.77,-9.09 -2.08,-13.5 2.83,-4.68 8.31,-5.01 12.93,-2.83 3.37,1.55 6.08,4.59 9.82,8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1448.23 1405.45c3.06,2.02 6.12,4.63 8.13,7.68 1.35,2.07 1.93,5.75 0.93,7.87 -0.94,2.01 -4.47,4.18 -6.54,3.85 -4.55,-0.68 -8.83,-2.8 -14.64,-5.73 -3.8,-5.79 -4.92,-10.2 -0.71,-14.23 4.37,-4.15 8.88,-2.1 12.83,0.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2072.07 1486.8c-3.47,-1.94 -6.41,-4.64 -6.49,-8.49 -0.04,-2.32 1.94,-5.23 3.9,-6.87 3.11,-2.66 7.48,-2.53 10.46,-0.14 6.45,5.16 12.32,10.93 18.15,16.44 -0.25,-0.05 0.22,0.26 -1.92,-0.74 -9.46,-1 -16.59,4.01 -24.1,-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2946.16 2137.86c3.39,-6.72 9.69,-7.05 18.94,-0.82 0.76,0.45 1.07,1.55 2.23,4.01 -4.63,12.54 -8.14,14.68 -15.34,11.1 -5.96,-2.97 -8.47,-9.08 -5.83,-14.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2503.91 2254.59c-7.83,-2.59 -11.36,-9.21 -8.4,-15.34 3.1,-6.32 10.25,-8.78 17.03,-5.26 6.09,3.17 7.43,8.24 3.25,16.01 -4.5,3.79 -7.79,5.97 -11.88,4.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M621.32 671.7c2.95,8.28 -1.72,12.13 -11.56,12.12 -6.28,-3.94 -10.11,-8.24 -10.22,-14.15 -0.1,-2.29 1.63,-5.83 3.54,-6.67 6.35,-2.83 15.58,1.34 18.25,8.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1914.32 1111.01c-4.63,-0.81 -4.34,-7.72 -1.15,-11.95 2.72,-3.6 6.55,-3.24 10.27,-1.77 5.11,2.01 6.94,6.02 6.51,13.12 0.5,6.46 1.32,10.98 2.58,18.16 -8.06,-5.77 -8.67,-15.9 -18.21,-17.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M819.15 1180.44c8.95,0.34 15.61,1.71 19.37,8.24 1.29,2.18 1.59,5.74 0.74,8.06 -1.37,3.68 -4.76,6.06 -9.1,5.15 -7.73,-1.54 -15.12,-4.42 -19.05,-11.62 -3.12,-5.6 0.4,-8.74 8.04,-9.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1855.34 507.73c6.24,-3.09 11.61,-4.99 17.1,-5.53 6.37,-0.63 10.61,4.31 9.9,10.45 -0.67,6.13 -5.78,10.62 -11.5,9.48 -7.37,-1.45 -14.72,-3.46 -15.5,-14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1961.03 880.83c0.31,0.74 0.61,1.45 0.9,2.26 -4.32,7.25 -9.16,8.74 -15.1,5.44 -4.45,-2.48 -7.09,-6.68 -6.67,-11.58 0.57,-6.5 5.41,-8.09 11.77,-7.95 -0.16,-0.8 -0.42,-1.51 -0.5,-2.43 -3.38,-5.7 -7.23,-10.88 -1.24,-13.83 7.83,-3.81 17.79,-0.51 19.89,5.4 1.82,5.36 3.51,11 1.34,16.82 -1.51,4.06 -5.16,5.16 -10.39,5.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2088.84 1622.5c-2.44,-0.57 -3.09,-1.46 -0.09,-4.72 6.21,-3.95 10.69,-7.63 15.71,-10.02 1.67,-0.84 5.52,1.04 7.23,2.78 3.77,3.84 3.95,8.81 0.61,12.97 -1.5,1.92 -4.87,3.8 -7.04,3.46 -5.59,-0.88 -10.93,-3.11 -16.42,-4.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2651.88 1594.2c6.18,-4.18 12.56,-8.15 18.81,-12.19 6.4,5.87 11.79,11.38 5.84,21.77 -9.16,6.65 -16.24,3.03 -23.28,-0.27 -3.89,-1.76 -4.71,-6.99 -1.36,-9.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2176.61 1566.58c7.94,-0.96 13.32,3.08 13.83,10.42 0.42,6.25 -3,8.38 -14.16,8.85 -0.91,0.05 -1.78,-0.55 -4.17,-1.78 -4.66,-12.5 -3.17,-16.59 4.51,-17.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2065.13 617.93c1.78,-6.27 8.68,-8.87 13.31,-5.36 2.86,2.14 5.71,5.08 7.21,8.3 4.46,9.56 -0.75,16.7 -11.66,16.17 -2.5,-0.12 -4.87,-2.51 -8.16,-5.9 -0.85,-5.79 -1.71,-9.78 -0.7,-13.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2526.36 1363.68c-0.93,4.07 -5.13,5.23 -8.58,6.47 -8.6,2.97 -13.37,1.61 -16.81,-4.82 -3.89,-7.29 -1.29,-12.45 8.04,-15.73 5.47,1.77 8.94,3.27 12.09,5.24 3.16,1.95 6.16,4.79 5.26,8.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M402.24 1954.73c-3.07,6.3 -9.38,6.5 -17.55,1.55 -8.66,-5.22 -7.9,-9.95 2.73,-16.2 0.78,-0.42 1.87,-0.25 4.61,-0.27 9.24,2.46 14.38,6.52 10.2,14.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1690.83 1988.91c5.49,1.93 9.39,1.87 12.95,2.92 5.52,1.58 7,6 5.76,11.18 -0.88,3.89 -3.14,7.05 -7.37,7.61 -6.63,0.87 -10.25,-3.27 -13.45,-8.46 -3.04,-4.96 4.77,-9.04 1.78,-13.57 0.13,0.08 0.19,0.18 0.34,0.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1689.48 1987.39c0.43,0.41 0.75,0.79 1.01,1.2 -1.22,-1.11 -0.93,-1 -1.01,-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1981.83 241.19c-0.57,-5.12 1.7,-9.12 6.54,-11.21 4.12,-1.71 7.4,0.52 10.13,3.04 4.56,4.26 4.62,9.94 2.79,17.16 -14.27,1.25 -18.56,-1.05 -19.47,-8.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2876.19 500.55c-9.09,11.66 -15.2,4.75 -21.49,-1.21 12.38,-15.6 12.94,-15.56 21.49,1.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2118.76 1266.89c-5.99,3.65 -11.15,1.75 -14.65,-4.23 -1,-1.61 -1.42,-3.56 -2.05,-7.34 1.46,-4.34 2.41,-7.72 4.66,-8.98 6.31,-3.58 11.09,-0.16 14.59,5.02 3.47,5.07 2.38,12.48 -2.55,15.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2221.76 1272.02c-0.77,0.46 -1.47,0.92 -2.31,1.36 -2.44,-0.23 -2.44,-0.23 -2.66,-0.17 1.68,-0.82 3.34,-1.21 4.97,-1.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2247.36 1267.03c1.33,2.01 1.93,5.59 1.04,7.8 -1.93,5.06 -6.81,6.98 -11.71,5.44 -3.49,-1.13 -6.44,-4.04 -9.48,-6.28 -1.77,-1.33 -3.62,-1.93 -5.44,-1.97 5.43,-3.15 9.11,-6.72 13.38,-9.1 4.82,-2.85 9.46,-0.17 12.23,4.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2424.23 356.8c-3.74,-1.93 -5.56,-5.43 -4.87,-9.54 0.74,-4.24 4.04,-7.21 8.05,-6.89 7.67,0.56 15.28,2.22 22.12,6.72 -11.98,13.56 -15.8,14.69 -25.31,9.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1526.95 925.5c1.19,-5.95 5.82,-6.42 12.62,-4.55 4.21,3.55 7.45,5.97 8.95,9.17 0.89,1.89 -0.23,5.78 -1.82,7.59 -3.5,4.04 -8.48,3.97 -12.99,1.86 -5.77,-2.75 -8.02,-7.94 -6.75,-14.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2508.74 2546.35c-4.46,-1.95 -6.38,-9.27 -3.32,-14.74 1.18,-2.18 4.4,-3.2 8.54,-4.96 3.55,0.41 5.62,0.71 7,1.8 5.7,4.5 5.25,9.61 0.48,14.36 -3.42,3.48 -7.67,5.72 -12.7,3.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2386.8 2844.71c-3.45,-4.33 -1.58,-9.08 1.51,-12.78 1.68,-1.99 4.53,-3 8.5,-4.38 5.8,1.05 7.67,4.18 8.39,8.02 0.88,5.06 -0.41,9.34 -5.6,11.38 -4.66,1.81 -9.55,1.82 -12.8,-2.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1335.66 456.17c-6.09,3 -10.48,2.56 -13.03,-2.5 -1.84,-3.56 -1.15,-7.59 2.03,-10.12 3.99,-3.05 8.92,-3.3 12.9,-0.1 4.68,3.75 3.24,8.02 -1.9,12.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2305.25 2018.41c-3.22,-7.62 -0.31,-12.71 7.1,-15.49 0.88,-0.34 1.88,-0.11 4.51,0.33 7.72,10.72 7.48,14.54 0.42,18.47 -4.49,2.53 -10.1,1.19 -12.03,-3.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2166.47 1675.72c-2.09,15.46 -2.47,16.6 -12.45,13.48 -6.7,-2 -19.06,1.55 -19.27,-7.28 -0.29,-12.32 11.85,-2.36 17.82,-5.56 3.93,-2.13 9.15,-1.97 13.9,-0.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1602.14 2218.97c-3.59,-0.08 -5.57,-0.15 -7.17,-0.98 -4.7,-2.38 -7.23,-6.18 -4.97,-11.53 1.62,-3.82 5.27,-5.45 9.14,-5.63 5.05,-0.24 9.52,1.69 11.25,6.8 1.9,5.75 -2.27,8.48 -8.24,11.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1418.25 2486.04c-1.26,-2 -1.41,-5.82 -0.32,-7.93 2.24,-4.36 6.11,-7.99 11.44,-7.25 5.86,0.8 11.16,3.19 9.73,12.46 -3.3,3.19 -5.61,5.09 -8.25,6.17 -4.92,2.02 -9.7,0.96 -12.6,-3.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1703.94 1702.5c-4.13,-7.3 -8.66,-14.69 -8.69,-23.32 0.03,-4.42 3.86,-6.16 7.98,-5.9 4.37,0.28 6.21,3.64 7.74,9.46 1.73,6.52 3.37,10.9 4.67,15.43 0.86,3.33 -1.47,5.14 -4.17,6.29 -2.93,1.22 -6.19,0.39 -7.52,-1.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2788.23 703.77c1.66,-8.51 1.4,-17.6 11.1,-15.59 7.14,1.54 4.86,9.35 4.94,14.86 -0.01,3.79 -0.31,7.64 -0.96,11.4 -0.77,4.6 -7.63,5.73 -11.58,2.12 -3.12,-2.88 -3.54,-6.62 -3.5,-12.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2759.34 59.25c3.22,-1.29 5.32,-2.3 6.77,-1.75 8.79,3.21 11.95,8.52 8.8,13.96 -3.28,5.7 -10.81,7.5 -17.05,3.14 -6.13,-4.26 -3.94,-9.47 1.48,-15.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2519.59 697.23c1,3.37 1.47,5.26 1.21,7.07 -0.72,5.01 -2.96,8.81 -8.57,9.4 -4.11,0.43 -7.23,-1.55 -9.09,-5 -2.44,-4.45 -2.44,-9.23 0.92,-12.98 4.59,-5.11 9.77,-4.22 15.54,1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2531.67 823.42c1.86,-5.01 9.21,-6.39 14.93,-3.46 3.7,1.95 6.03,5.29 5.52,9.19 -0.66,5.3 -4.48,8.12 -11.66,8.1 -7.57,-3.01 -11.3,-7.16 -8.79,-13.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2813.32 160.49c0.27,-6.49 5.16,-12.24 10.25,-11.15 7.29,1.52 7.42,7.49 6.97,13.41 -0.05,0.95 -0.45,1.83 -1.96,3.95 -12.38,1.47 -15.52,-0.18 -15.26,-6.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M3164.69 1407.27c2.33,-5.07 8.99,-6.2 15.18,-3.24 5.73,2.78 5.65,6.89 -1.9,16.61 -3.55,0.68 -5.74,1.31 -7.25,0.48 -5.95,-2.72 -9,-7.35 -6.02,-13.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2933.89 1892.97c-0.23,-4.39 -0.48,-7.59 0.93,-9.81 3.39,-5.64 8.88,-7.22 15.04,-5.11 1.56,0.54 3.51,2.31 3.85,3.88 1.52,6.96 -3.09,10.71 -8.24,13.64 -3.62,2.03 -7.43,1.64 -11.59,-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M791.5 1748.78c1.45,1.72 2.05,5.42 1.33,7.67 -1.93,5.9 -9.88,8.1 -16.68,4.08 -6.24,-3.63 -6.21,-8.73 1.01,-14.31 6.58,-2.33 11.17,-1.11 14.34,2.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2121.7 573.53c0.64,-4.04 3.71,-6.42 7.88,-6.82 4.15,-0.41 7.36,1.63 9.62,4.9 4.94,7.27 1.38,14.82 -7.83,16.39 -3.69,0.64 -7.49,0.55 -10.52,-1.16 0.64,-5.78 0.16,-9.58 0.85,-13.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1249.28 1491.63c-5.12,8.51 -9.36,10.05 -20.72,6.07 0.84,-8.84 5.13,-13.67 11.97,-15.5 2.28,-0.6 5.64,0.4 7.67,1.87 2.42,1.67 2.69,4.96 1.09,7.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2094.06 314.66c-1.19,-3.92 0.62,-7.45 4.49,-9.34 3.9,-1.93 7.63,-0.88 10.62,1.61 4.74,3.98 6.66,9.25 4.71,15.34 -1.6,5.05 -4.9,7.97 -12.23,6.31 -3.68,-5.37 -6.17,-9.43 -7.59,-13.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2019.58 1221.29c1.79,-6.08 7.64,-9.68 15.79,-8.4 7.94,1.28 7.02,7.22 3.93,14.44 -6.4,4.6 -11.75,5.22 -16.82,1.27 -2.22,-1.71 -3.88,-4.11 -2.9,-7.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2288.75 629.73c-1.31,2.7 -1.78,3.5 -2.43,4.19 -2.79,2.82 -6.23,5.08 -10.09,3.55 -3.36,-1.32 -6.78,-3.49 -9,-6.24 -3.39,-4.21 -0.92,-11.25 4.38,-14.57 5.76,-3.57 10.08,-2.22 16.57,5.76 1,1.31 0.89,3.58 0.57,7.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1878.46 1925.43c-1.74,2.29 -3.88,4.1 -7.12,3.49 -6.1,-1.12 -10.49,-7.98 -8.66,-15.24 1.87,-7.25 7.03,-7.9 14.27,-3 3.66,5.93 4.87,10.34 1.5,14.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M3038.29 901.85c3.75,-5.37 5.85,-9.86 9.25,-12.91 3.16,-2.8 7,-0.91 9.85,2.06 3.58,3.77 6.09,8.82 2.44,12.54 -5.91,6.03 -13.93,9.53 -22.63,7.23 -2.35,-0.61 -1.35,-4.81 1.09,-8.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1783.31 1689.38c6.35,-3.65 12.62,-4.11 18.02,1.2 1.67,1.65 2.43,4.96 2.37,7.48 -0.08,3.07 -2.76,4.86 -5.8,4.99 -2.8,0.16 -5.62,-0.36 -10.11,-1.12 -8.38,-6.66 -9.05,-9.98 -4.48,-12.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2231.83 1632.91c2.24,-3.13 2.23,-5.09 2.75,-6.84 1.84,-6.21 5.6,-10.06 12.4,-7.47 5.06,1.98 6.58,6.52 4.81,11.61 -1.89,5.69 -6.68,5.97 -11.51,4.88 -3.53,-0.79 -6.7,-3.64 -8.45,-2.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M450.27 1255.8c5.37,-3.03 11.01,-3.52 15.64,1.35 4.04,4.25 3.04,8.49 -2.29,13.19 -8.19,1.94 -12.39,-1.58 -15.27,-7.02 -1.44,-2.67 -0.95,-5.91 1.92,-7.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2035.17 847.94c4.28,-3.16 8.9,-1.65 12.77,1.67 5.53,4.69 6.6,11.11 5.07,19.74 -10.47,3.84 -14.47,-3.37 -19.03,-8.98 -3.21,-4.08 -3.31,-9.18 1.19,-12.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M908.05 1782.33c-1.01,5.25 -5,8.03 -10.28,7.7 -5.07,-0.35 -8.37,-4.01 -11.79,-9.51 1.88,-10.56 8.8,-10.05 15.35,-8.8 5.36,1.01 7.79,5.32 6.72,10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2618.25 1843.62c5.14,-2.81 8.61,-4.72 12.59,-3.05 5.19,2.09 7.21,6.14 6.1,11.43 -1.27,6.13 -7.49,10.33 -12.74,8.43 -7.21,-2.63 -11.37,-7.24 -5.95,-16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2682.57 2263.6c-4.49,-6.11 0.04,-10.38 4.65,-14.15 2.15,-1.81 3.92,-4.1 6.04,-5.95 3.33,-2.71 7.56,-0.76 7.9,4.11 0.33,4.69 -0.43,9.42 -1.98,15.76 -6.73,4.61 -12.61,5.64 -16.61,0.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2376.4 594.16c2.04,-4.8 8.85,-5.64 11.04,-1.55 1.72,3.16 3.07,6.82 3.4,10.38 0.71,8.59 -4.29,10.31 -14.95,3.51 -0.35,-5.2 -0.74,-9.11 0.51,-12.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2192.71 436.46c3.4,-2.39 7.07,-2.48 12.21,0.41 1.83,4 2.78,6.83 2.56,9.52 -0.26,4.29 -3.11,7.08 -7.3,7.49 -5.41,0.46 -9.18,-2.77 -11.09,-7.44 -1.6,-3.91 0.3,-7.5 3.61,-9.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2316.59 478.95c3.68,-4.52 7.02,-3.82 16.31,5.1 -4.54,12.72 -9.15,15.25 -14.74,10.11 -4.86,-4.43 -5.45,-10.45 -1.57,-15.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M3099.19 238.04c-3.44,-5.82 -1.58,-14.42 4.62,-16.99 7.21,-3 9.88,2.45 11.04,10.04 -1.93,5.21 -4.19,8.24 -8.11,9.26 -2.82,0.68 -5.86,0.57 -7.55,-2.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2115.45 2181.81c11.98,2.28 14,4.58 12.21,10.56 -1.57,4.99 -4.95,7.99 -10.04,7.86 -5.32,-0.14 -7.53,-6.7 -5.61,-15.42 0.16,-0.81 1.19,-1.4 3.44,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2264.49 1511.67c5.72,-2.92 11.95,-0.8 13.95,4.8 2.13,5.95 -0.24,8.86 -11.84,11.82 -7.38,-10.42 -7.45,-13.97 -2.11,-16.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1798.02 933.02c3.43,4.97 5.02,8.52 3.72,12.47 -0.94,2.75 -2.02,5.52 -5.47,5.89 -6.54,0.64 -11.03,-2.87 -14,-8.08 -2,-3.46 -1.96,-7.4 1.11,-10.58 4,-4.06 8.46,-3.6 14.65,0.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1376.81 2094.7c-2.22,-3.8 -0.37,-8.19 2.91,-9.9 7.23,-3.86 14.59,-8.42 23.48,-3.69 -3.08,5.44 -5.85,9.4 -9.12,12.69 -1.94,1.91 -4.66,3.47 -7.22,4.14 -3.8,1.02 -7.94,0.38 -10.04,-3.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2614.56 2274.78c-3.86,-4.3 -2.81,-9 0.65,-12.77 4.56,-4.99 9.86,-5.11 15.82,1.27 1.66,7.3 -1.25,10.77 -5.94,12.82 -3.64,1.65 -7.61,1.91 -10.53,-1.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1952.64 1030.77c-1.79,0.27 -3.61,0.57 -5.2,-1.43 -1.97,-17.66 9.65,-20.27 20.07,-23.72 -0.16,0.09 0,-0.2 0.34,2.19 1.39,20.68 1.39,20.68 -15.21,22.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1864.89 1160.64c1.09,-2.62 2.05,-5.54 3.97,-7.4 3.21,-3.02 7.04,-2.83 9.98,0.65 2.67,3.13 2.51,6.93 0.57,12.34 -3.55,5.76 -7,9.63 -12.32,6.87 -5.36,-2.78 -4.16,-7.9 -2.21,-12.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M931.35 2203.2c2.64,-3.07 6.62,-4.59 10.24,-2.03 2.09,1.53 4.53,4.6 4.45,6.87 -0.16,6.1 -5.2,7.09 -11.89,7.15 -7.8,-3.6 -6.2,-7.99 -2.8,-11.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1994.97 2591.18c0.09,2.49 -0.98,5.58 -2.62,7.46 -3.49,4 -8.2,3.57 -14.42,0.53 -2.14,-4.09 -3.42,-6.85 -3.2,-9.47 0.61,-5.04 3.56,-8.53 9.16,-8.64 6.14,-0.1 10.88,3.92 11.08,10.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M3168.57 1073.47c2.11,-4.66 6.02,-7 13,-7.04 5.89,4.1 7.12,8.41 5.8,13.3 -1.72,6.14 -6.8,8.74 -13.13,7.07 -6.02,-1.59 -8.45,-7.24 -5.67,-13.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M3283.84 2074.75c-3.21,-4.45 -1.93,-9.3 1.82,-12.83 1.85,-1.71 5,-2.03 9.39,-2.37 3.29,3.01 5.57,5.24 5.91,7.77 0.86,5.31 -1.96,9.22 -7.01,10.94 -4.02,1.38 -7.88,-0.38 -10.11,-3.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M3051.51 836.34c2.59,-4.24 7.46,-6.46 12.24,-4.13 6.76,3.39 5.18,8.95 2.18,14.34 -0.45,0.8 -1.1,1.54 -3.22,3.29 -3.42,0.87 -5.56,1.31 -6.97,0.5 -5.97,-3.11 -7.68,-8.27 -4.23,-14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2166.19 1673.3c0.4,-2.1 1.24,-3.36 2.37,-4.12 -0.09,0.93 -0.14,1.86 -0.33,2.9 -1.87,1.49 -1.92,1.25 -2.04,1.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2167.63 1659.29c-0.56,-4.29 1.34,-7.67 5.68,-8.57 4.37,-1.02 7.3,1.94 9.17,5.42 2.13,3.84 1.03,7.22 -2.39,10.15 -3.06,2.63 -8.37,0.67 -11.53,2.9 0.2,-3.8 -0.53,-6.83 -0.93,-9.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2179.05 684.51c3.49,3.69 2.54,10.04 -1.81,11.97 -5.86,2.66 -11.03,2.14 -13.09,-5.23 -0.24,-0.87 -0.06,-1.81 0.53,-4.37 4.81,-8.09 9.77,-7.15 14.37,-2.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1185.99 1692.34c-1.83,6.59 -6.63,8.96 -13.15,5.29 -0.8,-0.41 -1.43,-1.21 -2.97,-3.44 -1.95,-8.94 1.08,-12.59 8.51,-11.62 5.41,0.83 9.17,4.13 7.61,9.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2917.81 1829.87c-0.98,-1.48 -1.05,-3.52 -0.95,-7.02 1.9,-2.94 3.01,-4.6 4.65,-5.37 5.08,-2.49 9.18,-0.63 11.75,3.96 2.71,4.72 1.48,9.2 -3.37,11.75 -4.68,2.43 -9.13,1.21 -12.08,-3.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2887.62 1308.48c3.64,6.26 2.16,11.46 -4.61,13.69 -4.95,1.66 -10.03,-0.32 -11.61,-5.79 -1.76,-6.16 3.15,-8.34 7.71,-10.19 0.89,-0.36 1.95,-0.22 4.6,0.04 2.44,1.01 3.44,1.49 3.91,2.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1513.18 710.66c4.77,-4.13 8.83,-1.34 12.55,1.98 0.65,0.64 0.95,1.72 1.49,4.22 -1.93,9.1 -6.61,10.72 -12.8,6.6 -4.29,-2.84 -4.72,-9.71 -1.24,-12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1161.03 808.39c2.72,5.02 -1.46,11.27 -8.19,12.15 -4.31,0.56 -7.08,-2.15 -9.01,-7.58 1.5,-3.81 2.82,-6.76 5.04,-8.04 4.8,-2.64 9.41,-1.67 12.16,3.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2802.69 944.02c-5.73,-0.89 -7.27,-5.41 -7.4,-10.34 -0.12,-4.94 1.79,-9.26 5.81,-12.25 3.74,-2.73 7.38,-1.7 9.48,1.94 1.34,2.28 1.28,5.38 1.6,10.25 -1.5,6.82 -3.4,11.25 -9.49,10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1215.2 1036.6c1.71,8.31 7.57,14.66 3.72,24.04 -6.2,-6.44 -11.09,-10.93 -15.28,-16 -3.33,-3.95 -4.55,-9.16 0.42,-12.6 3.54,-2.46 7.27,0.18 11.15,4.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1490.58 998.84c-9.1,-1.44 -11.24,-7.11 -6.17,-19.85 8.41,-0.51 12.44,3.14 15.1,8.81 1.38,3.09 0.6,6.08 -1.54,7.93 -1.96,1.74 -5.09,3.46 -7.38,3.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2783.12 2702.21c0.87,-2.17 3.93,-4.65 6.18,-4.84 4.85,-0.44 9.45,1.77 11.15,6.64 1.85,5.27 -0.7,8.91 -7.96,10.26 -7.7,-1.96 -12.06,-5.16 -9.37,-12.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2622.67 845.53c1.43,-2.01 4.25,-4.07 6.55,-4.29 5.2,-0.39 8.4,3.12 10.55,9.56 -2.21,9.2 -6.45,13.53 -14.28,9.29 -5.12,-2.76 -6.3,-9.41 -2.82,-14.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1045.51 2213.78c0.57,-5.4 7.42,-8.75 13.26,-6.31 3.77,1.58 4.97,5.23 4.22,11.02 -2.8,5.34 -6.04,6.51 -10.08,5.48 -5.16,-1.34 -7.98,-4.84 -7.39,-10.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2530.51 521.87c0.62,4.9 1.02,7.8 0.65,10.58 -0.74,4.93 -2.51,9.65 -8.77,8.88 -5.97,-0.77 -6.89,-5.8 -7.2,-10.77 -0.28,-4.95 1.11,-9.55 5.15,-12.75 3.67,-2.89 7,-1.43 10.17,4.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2488.55 1202.49c-6.6,0.07 -10.17,-3.38 -8.07,-12.3 3.15,-6.07 6.45,-10.11 11.64,-6.83 5.58,3.47 5.39,9.47 2.76,14.78 -1.02,2.05 -4.16,4.35 -6.32,4.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2526.43 1044.51c3.4,4.07 3.4,8.73 -0.85,12.57 -4.5,4.07 -10.94,2.63 -13.7,-3.51 -1.05,-2.26 -0.07,-5.47 1.1,-9.74 5.93,-4.98 10.22,-3.18 13.45,0.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1805.37 1949.31c-2.75,5 -10.16,5.95 -14.55,2 -5.09,-4.54 -4.92,-9.54 1.59,-15.07 4.47,-0.1 7.48,-0.12 9.74,1.16 4.9,2.69 5.8,7.31 3.22,11.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2024.9 1641.77c-7.31,-1.35 -11.03,-6.45 -9.1,-11.88 2.53,-7.08 7.99,-6.87 13.72,-3.83 0.8,0.41 1.4,1.21 3.01,3.48 1.07,7.63 0.9,13.91 -7.63,12.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2076.82 909.84c-1.76,3.22 -3.43,7.31 -8.18,5.38 -3.92,-1.61 -4.63,-5.71 -3.94,-9.34 0.68,-3.57 1.58,-7.73 3.91,-10.15 5.16,-5.52 9.58,-3.72 11.9,4.8 -1.43,4.24 -2.43,6.88 -3.69,9.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1988.81 2162.76c-0.38,-7.18 4.69,-9.28 10.94,-9.26 0.82,0.01 1.7,0.58 4.01,1.97 1.99,11.99 0.65,14.69 -5.43,15.11 -5.61,0.31 -9.27,-2.47 -9.53,-7.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1710.05 1647.28c-2.45,3.05 -12.9,3.6 -15.27,1.08 -0.81,-0.86 -0.7,-3.25 -0.1,-4.49 2.03,-4.43 5.31,-7.47 12.09,-7.06 4.22,3.58 6.02,6.98 3.29,10.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2525.12 1218.45c-5.8,-0.56 -9.28,-7.76 -6.25,-13 3.59,-6.2 8.63,-6.03 14.17,0.76 1.38,7.96 -0.53,12.97 -7.92,12.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2203.69 1464.14c5.62,-1.19 9.11,0.01 11.59,3.07 3.05,3.81 4.52,8.1 1.09,12.58 -3.31,4.36 -9.89,4.25 -14.61,-0.31 -4.97,-4.82 -4.4,-9.74 1.92,-15.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1832.37 1823.01c1.12,2.52 1.42,3.47 1.25,4.37 -1.01,6.69 -4.64,10.41 -11.54,8.39 -5.73,-1.67 -9.41,-8.8 -7.01,-13.46 3.32,-6.36 8.58,-6.35 14.21,-2.82 0.77,0.53 1.45,1.22 3.08,3.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M986.9 437.45c0.5,1.37 -0.46,3.87 -1.63,5.07 -1.13,1.3 -3.46,2.52 -4.88,2.19 -8.02,-1.96 -13.06,-8.34 -17.48,-14.29 -2.57,-3.43 1.73,-6.58 7.92,-6.98 8.18,3.36 13.72,7.22 16.08,14.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2260.9 1897.42c2.24,-0.85 5.86,-0.34 7.99,1 5.09,3.19 4.23,8.03 0.77,14.14 -12.06,2.75 -16.28,1.07 -16.67,-4.48 -0.38,-5.69 3.28,-9.02 7.91,-10.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2209.53 1077.3c-1.33,-4.5 -2.32,-7.4 -1.74,-10.08 0.55,-2.35 2.27,-5.03 4.29,-6.37 2.72,-1.73 5.75,0.06 7.42,2.31 2.15,2.93 4.12,6.21 5.13,9.68 1.06,3.78 -0.43,7.71 -4.18,9.45 -3.94,1.87 -7.15,-0.62 -10.92,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M987.33 953.05c-4.66,8.3 -10.87,3.87 -16.71,1.25 -0.82,-0.38 -1.62,-0.94 -3.46,-2.85 5.98,-9.95 11.59,-11.46 18.27,-5.68 1.66,1.35 2.8,5.66 1.91,7.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2964.09 652.28c-2.58,3.49 -6.69,3.41 -9.6,0.2 -5.29,-5.73 -3.37,-10.38 7.75,-15.51 7.11,5.27 5.35,10.65 1.84,15.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1451.23 808.89c3.49,4.64 1.9,8.81 -3.41,13.28 -5.8,1.35 -9,-0.3 -11.17,-3.87 -2.74,-4.63 -2.63,-9.24 2.14,-12.37 4.74,-3.07 9.18,-1.27 12.44,2.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2258.32 1036.8c5.63,1.78 7.07,6.52 5.51,11.4 -2.34,7.36 -7.33,7.81 -14.24,1.96 -0.05,-11.18 2.99,-15.11 8.73,-13.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2332.67 1583.27c-2.73,0.92 -5.44,-1.44 -6.2,-4.35 -1.41,-5.44 -3.22,-11.11 2.66,-16.97 10.46,1.8 10.08,8.66 8.67,15.37 -0.48,2.28 -2.97,5.18 -5.13,5.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2716.85 404.09c4.61,-5.59 9,-9.95 13.28,-2.26 2.47,4.38 1.13,9.71 -3.77,11.62 -6.73,2.61 -10.37,-0.6 -9.51,-9.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1023.47 437.18c3.14,2.55 3.99,7.22 1.08,9.93 -5.31,5.05 -9.97,3.43 -13.1,-4.8 1.7,-9.73 6.58,-9.39 12.01,-5.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2741.36 461.32c2.12,-1.06 5.59,-1.15 7.69,-0.12 3.48,1.63 4.83,5.27 4.3,10.86 -3.09,4.66 -6.44,6.6 -10.23,5.62 -2.36,-0.66 -5.2,-2.64 -6.11,-4.73 -2.08,-4.83 -0.23,-9.31 4.34,-11.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2661.19 1240.02c1.11,-1.98 4.76,-3.57 7.26,-3.64 4.2,-0.1 6.91,3.02 7.63,7.16 0.31,1.74 -0.62,3.69 -2.08,6.9 -3.6,3.14 -6.61,3.72 -9.07,2.01 -4.35,-3.01 -6.43,-7.59 -3.74,-12.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2709.96 2314.36c-2.84,-5.26 -0.35,-8.61 6.21,-10.55 3.21,1.06 5.25,1.58 6.37,2.87 3.5,4.04 3.67,8.82 -1.01,11.68 -4.62,2.85 -9.11,0.64 -11.57,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2957.89 1531c2.97,-2.29 4.65,-3.28 6.53,-3.66 4.37,-0.86 7.09,1.71 9.12,5.23 1.65,2.83 1.01,5.68 -0.9,7.93 -3.59,4.23 -8.46,4.65 -12.93,2.12 -3.54,-2.04 -4.48,-5.92 -1.82,-11.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1457.68 1499.37c1.85,7.96 -4,9.26 -12.05,8.86 -7.84,-4.96 -8.73,-9.8 -1.9,-13.67 5.92,-3.3 12.65,-1.02 13.95,4.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M470.09 715.78c-6.87,6.77 -13.31,3.79 -14.72,-8.59 5.61,-3.66 10.03,-4.56 14.14,-0.99 3.32,2.91 3.65,6.55 0.58,9.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2470.95 1735.78c2.95,-4.55 7.96,-5.23 12.92,-3.86 5.95,1.58 6.89,5.96 4.12,12.89 -6.04,3.68 -10.67,4.4 -15.08,1.15 -3.73,-2.8 -4.16,-6.73 -1.95,-10.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2490.14 1982.56c-0.78,-7.02 2.76,-10.43 11.55,-8.08 4.68,7.01 4.2,12.08 -3.33,13.81 -3.99,0.84 -7.71,-1.59 -8.22,-5.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2764.84 771.97c0.44,-4.06 2.51,-7.39 6.38,-8.77 4.03,-1.39 7.4,0.51 10.96,5.13 0.21,4.26 0.13,7.29 -1.27,9.52 -2.28,3.59 -6.15,4.66 -10.1,2.96 -3.67,-1.6 -6.45,-4.35 -5.97,-8.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M509.35 772.07c-5.96,5.35 -10.15,1.5 -13.61,-5.85 2.11,-8.88 6.78,-10.77 12.58,-6.38 4.05,3.08 5.25,8.4 1.03,12.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M451.13 2198.68c1.15,2.25 0.68,5.26 -0.07,9.57 -3.66,2.23 -6.41,3.61 -8.9,3.25 -4.14,-0.52 -6.54,-4.08 -6.82,-7.85 -0.28,-3.94 2.09,-7.31 6.08,-8.36 3.69,-0.94 7.82,-0.5 9.72,3.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2693.15 2802.25c0.15,-1.69 1.43,-3.33 3.51,-5.67 3.8,0.24 6.86,0.53 8.53,2.22 2.85,2.84 3.04,7 0.27,9.87 -1.59,1.66 -5.02,2.53 -7.29,2.07 -4.25,-0.74 -5.33,-4.6 -5.02,-8.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M481.27 2199.69c7.72,-1.49 13.76,-1.33 13.34,6.61 -0.31,5.74 -5.93,6.23 -10.62,6.39 -0.9,-0.02 -1.83,-0.3 -2.72,-0.49 -5.16,-0.89 -5.67,-4.44 0,-12.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1712.56 1837.1c6.02,-7.52 9.9,-8.04 21.7,-1.53 -3.17,13.53 -12.31,9.24 -19.94,8.11 -3,-0.45 -3.71,-4.1 -1.76,-6.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1347.17 1660.6c-2.39,5.3 -10.36,5.33 -14.1,-0.06 -3.78,-5.49 -0.22,-8.53 6.48,-10.21 7.38,1.12 9.99,4.91 7.62,10.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2304.82 1191.21c-0.79,-0.18 -1.61,-0.44 -2.51,-0.78 -4.39,-6.85 -4.8,-12.18 0.54,-16.76 2.92,-2.49 6.23,-4.53 8.84,-7.26 2.42,-2.58 1.04,-5.52 -1.09,-7.51 -1.2,-1.13 -3.42,-1.71 -5.13,-1.63 -8.57,0.28 -11.79,9.72 -20.92,12 -8.25,-10.29 -19.42,-16.7 -33.94,-16.83 -3.76,-0.03 -6.09,-4.8 -4.34,-9 1.44,-3.5 3.89,-6.55 9.26,-9.86 12.59,-0.73 22.41,-3.73 30.9,0.66 10.36,5.35 18.73,-6.51 29.23,-0.95 0.5,-0.56 1.04,-1.19 1.75,-1.86 6.28,-3.88 11.02,-6.86 15.67,-9.92 8.36,-5.49 15.8,-3.34 22.89,2.51 3.41,2.89 6.01,6.24 5.18,10.99 1.07,0.3 2.08,0.57 3.25,0.97 3.05,1.09 4.31,2.28 6.15,5.55 0.18,0.18 0.29,0.38 0.49,0.56 0.07,-0.48 0.14,-0.98 0.3,-1.52 4.3,6.27 10.54,9.89 9.15,16.07 0.79,0.9 1.67,1.74 2.72,2.56 0.98,3.22 1.07,5.33 0.41,8.65 0.78,-0.03 1.58,0.01 2.58,0.22 9.81,10.38 6.89,24.7 16.24,33.72 1.11,1.03 0.07,6.45 -1.56,7.79 -4.33,3.49 -11.32,4.67 -14.02,8.87 -4.44,6.78 6.57,10.72 5.87,17.7 -0.42,3.77 0.74,8.78 -1.29,11.18 -6.46,7.57 -3.77,13.63 0.9,20.43 1.25,1.89 0.82,5.58 -2.87,6.91 -3.08,1.08 -5.31,-0.1 -7.84,-1.65 -7.45,-4.5 -1.2,-15.32 -9.67,-19.7 -7.46,-3.87 -10.01,-11.32 -10.73,-19.35 -0.36,-3.92 -3.26,-5.88 -5.73,-9.48 -1.04,0.45 -2.04,0.88 -3.21,1.25 -5.78,-0.07 -9.67,-0.65 -15.26,-2.15 -0.19,-0.14 -0.36,-0.3 -0.54,-0.45 0.11,0.63 0.24,1.25 0.33,1.88 -7.68,-0.94 -13.4,-2.84 -14.95,-9.49 -0.55,-0.25 -1.13,-0.5 -1.7,-0.84 0.23,-0.43 -0.19,0.46 -1.43,-0.9 -0.48,-0.29 -0.91,-0.59 -1.37,-0.86 0.12,0.7 0.29,1.37 0.4,2.05 -17.86,-8.21 -17.86,-8.21 -13.04,-23.64 0.07,-0.05 0.12,-0.09 0.12,-0.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2111.33 1730.37c4.7,2.41 3.63,7.62 -4.74,15.41 -8.37,-2.07 -11.29,-6.1 -7.46,-12.49 2.85,-4.63 7.61,-5.29 12.21,-2.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2788.68 402.38c-2.45,-7.09 -1.72,-13.04 8.67,-15.28 7.36,4.61 8.13,10.03 5.77,15.67 -0.93,2.26 -3.64,4.71 -5.95,5.23 -3.99,0.86 -7.14,-1.75 -8.49,-5.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1153.63 1778.91c6.06,-1.29 11.81,-1.22 12.2,8.58 -4.54,5.77 -9.12,5.14 -13.67,2.44 -2.67,-1.54 -3.64,-4.57 -2.53,-7.42 0.59,-1.5 2.44,-3.24 4,-3.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2186.02 1402.04c0.3,-4.17 2.97,-7.53 7.01,-8.04 4.17,-0.5 7.17,2.53 8.17,6.58 0.97,4.07 -0.51,7.66 -4.36,9.62 -3.34,1.71 -7,2.91 -10.6,4.56 0.06,-0.12 0.31,-0.61 0.57,-2.1 -0.11,-4.95 -1,-7.83 -0.79,-10.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2186.23 1414.75c0,0.02 0,0 0,0 -0.04,0.04 -0.04,0.06 0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2652.23 1680.44c-4,5.23 -7.51,4.63 -14.33,-4.11 1.89,-7.33 3.81,-13.15 11.38,-9.87 5.99,2.67 6.94,8.85 2.95,13.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1946.15 1960.28c-4.38,6.13 -9.97,2.39 -14.79,-0.68 -0.7,-0.49 -1.12,-1.46 -2.05,-3.89 1.75,-8.45 6.28,-10.72 12.39,-7.12 4.19,2.49 7.69,7.23 4.45,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1499.56 1960.12c0.65,-6.88 5.57,-8.92 12.04,-7.81 0.99,0.19 1.81,0.6 4,2.47 0.76,11.71 -1.51,15.17 -7.53,14.38 -5.11,-0.72 -9.03,-3.62 -8.51,-9.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M3037.79 1611.36c2.72,-2.96 5.07,-5.09 7.62,-5.37 4.35,-0.58 7.09,2.19 7.67,6.46 0.61,4.81 -4.28,8.28 -9.95,6.38 -2.26,-0.75 -3.77,-3.85 -5.35,-7.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2757.42 1159.61c-3.44,-4.83 -0.55,-11.96 5.67,-13.48 7.95,-1.94 9.81,3.38 9.24,11.75 -5.44,6.99 -10.57,7.78 -14.91,1.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M982.19 1092.61c-0.91,-0.11 -1.77,-0.66 -4.19,-2.31 -4.46,-7.87 -3.05,-12.85 4.51,-13.58 6.29,-0.61 11.83,5.05 10.84,10.5 -1.16,6.22 -6.17,6.24 -11.15,5.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1700.37 2041.97c-4.37,-3.93 -2.79,-8.24 2.53,-12.96 6.77,-0.94 10.9,0.67 13.51,5.21 1.56,2.72 1.2,5.61 -1,7.5 -4.82,4.19 -10.27,4.51 -15.04,0.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1676.27 1212.33c2.42,0.95 4.64,3.13 6.09,5.37 1.63,2.56 1.32,5.87 -1.15,7.71 -2.09,1.54 -4.95,2.8 -7.53,2.83 -5.42,0.08 -8.44,-3.76 -10.33,-10.36 3.62,-6.17 8.07,-7.42 12.91,-5.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M448.72 2420.38c-5.97,1.58 -10.85,-1.72 -13.05,-7.23 -0.63,-1.54 1.65,-5.92 3.25,-6.34 3.31,-0.86 7.07,0.14 12.07,1.51 4.04,6.13 3.12,10.59 -2.27,12.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1980.94 1625.04c9.81,6.21 10.81,11.25 4.56,13.91 -4.8,2.09 -9.85,2.06 -12.44,-2.92 -2.9,-5.58 1.33,-8.68 7.88,-11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1979.14 1557.42c-4.3,10.25 -7.83,11.88 -13.54,8.15 -3.4,-2.22 -5.73,-5.6 -3.66,-9.55 1.14,-2.23 4.01,-4.31 6.45,-4.86 3.95,-0.88 7.25,1.57 10.75,6.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1976.86 1600.46c-4.94,4.13 -12.44,2.89 -14.58,-2.23 -2.51,-6.08 2.45,-8.19 6.88,-10.07 0.8,-0.38 1.8,-0.39 4.48,-0.01 5.9,4.05 8.02,8.3 3.22,12.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2509.41 573.71c-0.28,6.01 -3.72,8.52 -11.07,4.25 -1.86,-2.2 -2.48,-2.94 -2.88,-3.8 -2.36,-5.18 -1.85,-9.79 4.09,-11.57 5.32,-1.58 10.15,3.65 9.86,11.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1059.23 1777.39c-4.59,-0.99 -9.08,-3.29 -7.85,-9.25 1.14,-5.43 5.4,-7.1 10.51,-6.5 4.08,0.47 6.25,3.41 6.92,9.05 -2.58,5.19 -5.74,7.55 -9.58,6.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2614 2611.19c0.96,-8.39 4.3,-12.05 11.38,-8.82 3.64,1.68 6.74,4.59 5.11,8.87 -2.64,6.97 -8.09,6.5 -13.77,3.67 -0.8,-0.37 -1.39,-1.27 -2.71,-3.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2599.04 1451.63c-0.01,-6.08 4.52,-8.2 9.91,-7.36 2.61,0.36 4.94,2.65 8.32,5.83 0.58,7.9 -3.36,9.89 -8.73,9.9 -5.59,0.01 -9.56,-2.58 -9.51,-8.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1739.7 586.65c-0.96,7.21 -4.07,10.33 -9.5,7.76 -5.7,-2.77 -7.42,-9.97 -3.43,-13.72 6.08,-5.74 9.58,-0.7 12.93,5.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1630.74 1592.57c-5.51,2.6 -9.72,-0.14 -12.42,-4.24 -3.4,-5.1 -1.24,-8.95 6.47,-10.64 9.8,7.02 11.27,12.39 5.95,14.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2054.48 802.43c-12.47,-1.72 -16.3,-5.49 -13.75,-11.8 0.89,-2.02 4.57,-4.7 6.44,-4.3 7.87,1.52 10.62,6.95 7.31,16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1569.23 1552.6c6.78,3.3 6.49,8.41 -0.21,14.32 -7.37,0.38 -14.54,1.26 -12.97,-7.49 1.12,-6.16 7.85,-9.39 13.18,-6.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M3105.99 1306.48c-3.68,-6.72 0.55,-10.24 7.93,-12.67 4.95,2.84 6.05,6.53 5.37,10.25 -0.43,2.41 -2.17,5.32 -4.19,6.4 -4.01,2.14 -7.3,-0.69 -9.1,-3.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2973.13 302.76c0.81,-2.25 3.49,-4.94 5.73,-5.32 4.41,-0.79 7.09,2.52 7.43,6.65 0.57,6.81 -1.96,11.16 -11.12,8.17 -1.61,-4 -2.79,-7.08 -2.03,-9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2200.93 1539.03c-4.81,2.27 -8.96,-0.28 -11.75,-4.52 -2.15,-3.35 -2.67,-7.16 0.21,-10.28 4.45,-4.84 8.22,-1.47 12.94,3.25 2.08,5.43 2.43,9.69 -1.39,11.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2702.04 540.83c0.91,-5.71 4.4,-7.87 11.48,-4.74 4.4,5.89 3.96,10.37 -0.36,13.64 -1.81,1.4 -5.64,1.93 -7.57,1 -3.73,-1.83 -4.21,-6.06 -3.56,-9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2745.45 1628.59c-2.89,1.65 -4.97,2.37 -6.54,1.88 -5.05,-1.72 -7.82,-5.35 -6.28,-10.87 1.12,-3.94 4.17,-6.69 8.34,-6.21 6.54,0.78 5.89,6.23 6.02,10.91 0.01,0.94 -0.33,1.86 -1.54,4.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2568.91 439.06c-2.19,8.68 -6.93,11.03 -12.25,5.8 -3.39,-3.44 -2.77,-9.51 1.62,-12.49 5.16,-3.53 8.53,-0.11 10.63,6.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M218.44 2271.73c-7.65,0.62 -14.46,0.86 -12.52,-7.81 1.43,-6.09 8.01,-7.82 13.94,-4.25 5.35,3.28 4.71,7.49 -1.43,12.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2578.42 559.45c-5.66,-3.45 -6.54,-12.88 -1.79,-16.95 1.5,-1.29 5.47,-1.04 7.52,0 3.47,1.72 4.84,5.44 4.03,11.24 -2.87,4.99 -6.07,7.97 -9.76,5.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2215.58 490.37c-4.02,-1.15 -5.43,-5.6 -4.27,-9.39 2.12,-6.96 6.34,-9.01 13.09,-1.87 0.95,8.31 -0.91,13.46 -8.82,11.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1661.82 1094.99c2.9,-3.07 6.79,-2.8 10.02,-0.58 5.75,3.98 5.87,8.62 -0.86,13.86 -4.14,-0.95 -6.75,-1.88 -8.69,-3.73 -3.07,-2.76 -3.44,-6.42 -0.47,-9.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2108.12 1984.28c-4.61,-3.84 -5.66,-7.45 -3.52,-10.99 2.17,-3.61 6.2,-4.9 9.74,-2.79 4.57,2.67 5.43,7.68 4.23,12.41 -1.42,5.18 -5.38,3.59 -10.45,1.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1622.37 1402.09c5.74,1.92 5.15,6.97 2.74,11.66 -0.83,1.68 -1.46,3.66 -2.71,4.95 -1.12,1.17 -2.98,1.59 -4.59,2.31 -1.08,-2.35 -2.16,-4.73 -3.51,-8.93 0.27,-6.96 1.86,-12.04 8.06,-10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2279.86 387.87c4.77,-2.08 9.7,-2.08 12.1,2.94 2.47,5.09 -1.18,8.72 -7.18,11.61 -9.73,-8.38 -10.46,-12.1 -4.92,-14.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1674.56 620.08c3.64,-0.29 7.91,0.44 8.38,5.2 0.86,7.96 -5.01,8.46 -10.77,8.67 -0.91,0 -1.83,-0.43 -4.06,-1.75 -3.82,-8.45 -0.14,-11.69 6.45,-12.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1796.8 1732.06c6.8,0.4 10.67,2.6 9.02,8.49 -1.39,5.02 -6.71,6.76 -10.88,3.58 -4.83,-3.6 -3.65,-7.66 1.86,-12.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2964.08 878.87c-2.27,-3.49 -1.27,-7.36 2.01,-9.6 3.12,-2.15 6.95,-2.31 9.89,0.91 1.18,1.29 1.79,3.03 2.17,6.58 -1.92,3.06 -3.16,4.55 -4.7,5.24 -3.92,1.73 -7.3,0.08 -9.37,-3.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2677.1 1884.97c-1.07,1.39 -2.91,2.18 -6.15,2.63 -2.86,-2.04 -4.45,-3.37 -4.92,-5.03 -1.15,-4.19 0.92,-7.25 4.87,-8.53 1.34,-0.43 3.54,0.44 4.93,1.39 3.7,2.59 3.97,6.09 1.27,9.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2462.33 576.82c-1.79,2.67 -4.49,3.67 -7.43,2.72 -4.17,-1.25 -6.16,-4.4 -5.28,-8.7 0.35,-1.78 1.76,-3.32 4.5,-5.64 3.57,0 5.58,0.38 6.97,1.48 3.42,2.85 3.6,6.48 1.24,10.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M3174.85 1646.05c2.06,0.09 5.37,2.91 5.63,4.81 0.95,7.35 -3.33,9.61 -11.44,7.02 -3.67,-7.99 -1.54,-12.15 5.8,-11.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1675.36 930.18c1.33,0.77 2.66,2.94 2.6,4.51 0.07,4.43 -2.89,6.77 -6.99,6.93 -2.74,0.16 -5.51,-0.78 -8.31,-2.71 0.98,-3.07 1.89,-4.77 3.06,-6.19 2.55,-3.09 5.91,-4.71 9.64,-2.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2003.63 1947.47c-7.74,3.94 -12.41,2.5 -12.92,-5.01 -0.27,-4.05 2.66,-7.62 6.51,-7.73 7.26,-0.09 9.32,4.58 6.41,12.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1775.63 793.28c2.93,2.51 5.7,6.02 3.58,9.95 -1.06,1.91 -4.68,3.51 -7.03,3.36 -5.89,-0.39 -7.17,-5.37 -7.84,-12.17 4.3,-8.61 7.97,-3.94 11.3,-1.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M3147.88 863.88c-0.12,-2.31 2.14,-5.44 4.16,-6.93 3.62,-2.58 7.33,-0.99 11.12,3.55 -0.01,6.32 -2.84,8.97 -6.97,9.36 -4.01,0.41 -8.09,-1.48 -8.31,-5.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M3124.81 940.38c3.56,-6.19 7.43,-8.04 11.61,-3.51 3.61,3.94 2.56,9.31 -2.27,11.46 -5.69,2.55 -8.37,-0.93 -9.34,-7.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2555.02 956.68c1.38,5.29 -2.71,10.06 -7.9,9.25 -6.26,-0.97 -7.16,-5.49 -4.65,-12.35 6.5,-3.58 10.96,-2.99 12.55,3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1714.14 1791.59c-4.11,0.5 -7.71,-2.62 -7.81,-6.73 -0.18,-7.5 4.54,-9.65 13.08,-6.65 4.73,8.47 1.65,12.5 -5.27,13.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2488.5 1561.4c3.13,-7.23 7.93,-7.15 13.96,-0.5 -0.98,8.84 -4.59,12.04 -11.49,7.96 -2.66,-1.51 -3.71,-4.61 -2.47,-7.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1806.44 2586.92c-4.36,-0.01 -6.98,-3.53 -6.38,-7.79 0.84,-6.13 5.38,-7.1 12.23,-4.7 4.07,8.27 1.79,12.57 -5.86,12.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1779.62 1502.36c7.81,-4.19 12.06,-2.37 12.65,4.85 0.33,4.13 -2.84,7.26 -6.59,7.38 -7.14,0.21 -9.49,-4.07 -6.06,-12.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1541.42 1505.09c1.85,2.74 0.87,5.29 -1.35,7.31 -3.15,2.88 -6.65,3.09 -9.93,0.27 -1.29,-1.15 -1.92,-3.05 -2.48,-6.49 1.73,-2.99 2.93,-4.58 4.58,-5.17 4.15,-1.5 7.01,0.78 9.18,4.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1284.04 2513.98c-1.1,8.06 -4.37,11.56 -11.02,7.32 -2.42,-1.54 -3.64,-4.23 -2.3,-7.07 3.15,-6.7 7.64,-6.69 13.33,-0.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1542.41 1913.91c-1.3,5.14 -7.12,7.03 -11.57,3.83 -5.21,-3.75 -3.82,-8.1 1.88,-12.73 7.13,0.39 11.21,2.64 9.68,8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2370.19 1851.06c-2.29,-0.79 -4.97,-3.32 -5.41,-5.5 -0.45,-2.15 0.94,-5.75 2.78,-7.09 1.91,-1.37 5.25,-0.88 8.89,0.37 1.33,3.36 2.18,5.31 1.74,6.91 -0.92,4.07 -3.71,6.83 -8,5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2374.87 1824.28c0.99,-4.12 4.4,-6.1 8.41,-4.81 2.4,0.77 5.11,2.66 6.19,4.8 1.81,3.67 0.47,7.45 -3.42,9.24 -3.33,1.56 -6.99,2.47 -10.45,3.67 0,0 -0.06,0.09 -0.31,-2.21 -0.31,-5.09 -1.03,-8.02 -0.42,-10.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1320.63 3048.63c0.68,-7.18 4.13,-9.34 9.56,-6.77 2.74,1.31 4.37,3.97 2.49,7.02 -3.11,5.02 -6.96,5.73 -12.04,-0.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1100.75 1855.86c-0.92,4.31 -4.1,6.11 -8.29,5.8 -2.98,-0.28 -5.41,-1.97 -6.02,-5.08 -0.83,-4.23 0.99,-7.37 5.07,-8.7 1.61,-0.53 3.61,0 6.95,1.34 1.82,3.08 2.63,4.98 2.3,6.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1829.02 607.87c2.16,0.97 4.51,3.36 5.19,5.59 1.15,3.94 -0.96,7.33 -4.89,8.6 -3.49,1.14 -7.26,1.38 -10.87,-0.03 0.38,-4.82 0.07,-7.93 1.39,-10.21 1.8,-3.36 5.18,-5.77 9.18,-3.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M3035.45 1548c3.3,-2.34 7.62,-1.43 9.66,1.98 3.66,6.17 0.75,10.16 -7.53,11.78 -7.2,-4.78 -7.86,-9.58 -2.12,-13.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1682.95 1530.18c-4.08,1.13 -7.93,-0.86 -8.54,-5.14 -1.15,-7.55 3.01,-10.11 11.63,-7.38 3.35,6.44 2.89,10.95 -3.08,12.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2641.09 802.35c-1.99,1.04 -5.58,0.82 -7.64,-0.29 -3.76,-2.01 -4.33,-6.28 -2.72,-9.79 0.94,-2.18 4.05,-3.39 8.15,-4.48 3.06,2.02 4.49,3.37 5.25,4.95 1.75,3.98 0.42,7.7 -3.04,9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M918.73 367.96c-1.44,3.73 -5.63,5.34 -9.03,3.33 -5.33,-3.17 -3.66,-7.38 1.5,-11.88 7.52,-0.2 9.63,3.43 7.53,8.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2011.89 263.51c4.24,-0.4 7.66,2.78 7.64,6.97 -0,6.49 -3.96,8.06 -11.07,4.44 -4.33,-6.84 -2.89,-10.81 3.43,-11.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M238.35 1305.5c-0.08,1.43 -1.89,3.76 -3.24,3.99 -7.32,1.29 -10.36,-2.52 -8.74,-10.89 8.08,-2.9 12.44,-0.87 11.98,6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1815.61 863.69c1.48,1.81 1.51,4.84 0.98,8.53 -3.79,1.04 -6.85,1.56 -8.85,0.43 -3.75,-2.13 -4.32,-5.95 -1.5,-9.27 2.87,-3.44 6.77,-2.84 9.37,0.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1797.33 401.41c3.3,7.94 1.06,11.93 -5.92,12.58 -3.06,0.27 -5.36,-1.77 -5.39,-4.8 -0.15,-6.55 2.85,-10.21 11.31,-7.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M730.87 904.16c-6.72,1.11 -11.96,-2.94 -11.34,-8.7 0.73,-6.83 6.11,-5.14 12.34,-2.78 4.3,5.54 5.96,10.34 -1,11.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2124.48 1353.93c-3.52,-2.25 -4.37,-6.67 -1.14,-9.96 3.36,-3.52 6.79,-1.68 10.07,3.19 -0.19,7.83 -3.6,10.21 -8.93,6.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1946.11 1040.44c-0.69,2.87 -2.79,4.68 -5.74,4.43 -2.96,-0.25 -5.09,-2.25 -5.37,-5.26 -0.29,-3.08 1.66,-4.94 4.56,-5.73 2.57,-0.73 5.19,-1.36 7.84,-2.18 -0.08,0.11 -0.31,0.55 -0.62,1.65 -0.53,3.45 -0.31,5.33 -0.67,7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1947.46 1031.69c-0.02,-0 -0.06,-0 -0.06,-0 0.04,-0.04 0.07,-0.06 0.06,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1686.26 712.38c-5.37,0.83 -8.73,-2.55 -8.45,-7.91 0.34,-6.5 4.54,-6.86 10.94,-3.6 3.62,6.04 3.88,10.53 -2.48,11.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1837.36 716.1c3.96,-5.81 8.05,-6.27 12.08,-2.43 2.89,2.77 4.04,6.3 0.92,9.66 -2.08,2.22 -5.07,2.36 -7.44,0.55 -2.14,-1.61 -3.73,-3.91 -5.57,-7.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1742.13 965.6c3.12,-6.59 8.6,-5.09 14.01,1.28 0.14,6.97 -1.69,11.14 -7.81,9.25 -4.96,-1.49 -8.37,-6.05 -6.2,-10.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M3193.43 1478.75c-0.87,-4.24 1.61,-7.67 6.03,-7.41 4.9,0.3 5.65,4.1 3.54,9.6 -5.17,3.42 -8.59,2.43 -9.57,-2.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2492.65 412.12c-4.98,-3.98 -8.7,-7.5 -4.09,-11.96 2.89,-2.76 7.02,-2.62 9.51,0.74 3.9,5.25 3.96,9.99 -5.42,11.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M13.49 1282.67c0.26,6.39 -4.43,7.19 -11.14,4.8 -3.68,-6.23 -3.32,-10.69 3.13,-11.35 3.96,-0.38 7.83,2.76 8.01,6.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2104.91 680c0.35,7.2 -2.29,10.62 -8.03,8.53 -5.02,-1.86 -7.06,-6.39 -4.13,-11.01 3.62,-5.61 7.78,-2.35 12.17,2.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1898.36 2257.88c-2.41,-6.17 2.42,-7.92 9.15,-8.93 6.65,3.26 8.73,7.22 4.56,11.6 -4.15,4.46 -11.52,3.05 -13.71,-2.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1651.28 406.19c-2.53,4.42 -6.45,3.42 -9.82,0.84 -1.42,-1.14 -2.17,-3.14 -3.04,-6.54 2.92,-5.4 6.46,-6.39 10.24,-4.18 3.75,2.2 4.76,6.13 2.62,9.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2700.58 505.55c0.05,6.02 -2.2,9.05 -6.92,7.59 -4.28,-1.31 -5.73,-5.39 -3.15,-9.02 2.57,-3.66 6.4,-3.85 10.07,1.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M954.57 906.04c3.71,6.45 3.24,11.05 -3.35,11.52 -3.89,0.25 -7.81,-3.01 -7.96,-6.96 -0.36,-7.09 4.85,-6.81 11.32,-4.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2703.21 1784.46c0.3,-7.42 3.81,-8.89 8.84,-6.71 2.81,1.18 3.87,4.08 2.72,6.76 -1.65,3.94 -5.16,4.25 -8.85,2.99 -0.85,-0.24 -1.5,-0.98 -2.71,-3.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1932.88 1574.95c1.25,-0.6 4.12,-0.07 4.92,0.92 3.54,4.64 2.92,8.52 -4.72,10.17 -6.05,-4.53 -5.78,-8.35 -0.2,-11.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2879.81 1434.68c-0.13,-6.08 4.28,-7.3 10.94,-4.78 3.46,6.21 2.93,10.66 -3.22,11.29 -3.87,0.41 -7.63,-2.72 -7.71,-6.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2615.53 1903.12c2.66,4.09 1.88,6.72 -0.18,8.94 -2,2.27 -4.87,3.82 -7.53,2.14 -3.8,-2.48 -4.44,-6.56 -1.24,-9.73 1.68,-1.67 5.02,-1.71 8.95,-1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1754.32 2567.73c-2.2,-4.08 -0.03,-6.67 5.66,-7.29 4.7,2.95 6.35,6.27 3.08,9.35 -3.23,3.13 -6.91,1.39 -8.74,-2.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1798.13 1009.61c2.51,3.21 2.3,7.84 -1.22,9.74 -5.4,2.94 -8.27,-1.15 -9.96,-7.61 3.65,-6.85 7.75,-6.52 11.18,-2.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2063.9 1768.26c3.54,-1.32 5.44,-1.88 7.32,-1.65 4.45,0.42 7.1,2.77 6.62,7.5 -0.49,4.91 -5.66,7.17 -11.23,4.87 -4.18,-1.77 -5.18,-5.28 -2.71,-10.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M745.05 674.87c2.69,5.56 -0.08,8.77 -7.55,9.41 -5.68,-3.74 -9.11,-7.45 -4.24,-12.11 3.86,-3.57 9.39,-2.28 11.79,2.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2072.68 2190.83c-6.2,0.26 -7.77,-3.65 -4.8,-10.6 6.34,-4.12 10.47,-3.03 11.34,3.02 0.55,4 -2.62,7.46 -6.54,7.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1234.7 2633.2c-7.26,-0.04 -10.28,-2.79 -7.6,-8.38 1.75,-3.53 5.73,-5.5 9.17,-3.44 5.25,3.12 3.87,7.41 -1.56,11.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2355.83 1450.57c-0.05,-3.79 1.45,-7.71 5.62,-8.11 3.88,-0.38 7.09,2.37 7.32,6.41 0.15,2.41 -1.54,4.88 -4.23,7.89 -5.83,0.16 -8.69,-1.93 -8.72,-6.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2968.43 162.39c2.25,-1.69 5.42,-1.78 7.09,0.96 3.76,6.09 1.17,10.16 -6.81,12.39 -7.74,-5.33 -5.24,-9.69 -0.29,-13.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1998.77 340.99c-1.28,7.45 -5.44,9.81 -10.5,10.02 -2.35,0.06 -6.02,-1.46 -7.03,-3.34 -1.35,-2.58 0.83,-5.72 3.73,-6.47 3.68,-0.95 7.57,-0.97 12.02,-1.55 0.62,-0.1 1.86,-0.51 1.79,1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1186.4 2568.23c-3.27,5.15 -7.83,3.86 -12.51,-1.52 0.04,-7.67 3.29,-10.16 8.88,-7.73 3.65,1.62 5.95,5.67 3.63,9.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2291.33 231.17c2.97,-3.34 7.09,-3.36 9.8,0.19 1.48,1.97 1.28,5.21 0.77,9.33 -3.8,1.05 -6.98,1.53 -8.93,0.2 -3.58,-2.25 -4.79,-6.23 -1.64,-9.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1761.1 1111.23c6.71,-3.46 10.56,-1.29 11.66,4.1 0.89,4.26 -2.09,7.37 -6.37,7.1 -5.85,-0.35 -7.74,-4.29 -5.29,-11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2452.66 1979.4c-3.41,2.7 -6.85,2.36 -10.25,-2.88 0.96,-3.99 1.95,-6.88 3.98,-8.29 2.36,-1.71 5.65,-1.1 7.59,1.36 2.79,3.51 2.01,7.11 -1.32,9.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2464.92 2401.23c-0.21,-6.2 2.5,-8.5 7.07,-6.93 3.93,1.35 6.38,4.83 3.38,8.69 -2.84,3.61 -6.67,2.69 -10.45,-1.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2317.68 719.41c-3.04,-6.16 -3.81,-11.09 2.92,-11.96 4.3,-0.57 7.03,3.28 7.3,7.08 0.49,6.31 -3.08,8.25 -10.22,4.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2949.68 939.39c-2.72,-3.41 -2.15,-7.06 2.86,-10.67 3.51,0.37 5.56,0.83 6.87,2.11 3.15,2.86 4.65,6.58 0.55,9.63 -3.38,2.61 -7.48,2.47 -10.27,-1.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M3108.33 831.23c3.66,-5.53 7.17,-9.08 11.87,-4.36 3.57,3.61 2.34,9.22 -2.52,11.56 -5.32,2.56 -8.81,0.44 -9.35,-7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M66.28 1835.43c-7.52,2.92 -12.32,1.88 -10.87,-6.05 0.32,-1.86 3.66,-4.51 5.63,-4.55 5.78,0.06 7.24,4.13 5.24,10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M528.35 1160.42c-1.5,4.08 -5.92,5.08 -9.45,2.75 -4.6,-2.99 -5.9,-7.28 0.53,-12.11 6.98,0.8 11.05,3.49 8.91,9.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2421.52 2509.25c2.38,-3.85 6.28,-4.43 9.35,-1.45 1.62,1.54 1.45,4.94 0.97,8.7 -3.66,0.93 -6.64,1.26 -8.78,0.02 -2.51,-1.44 -3.06,-4.78 -1.54,-7.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M945.85 2011.87c2.57,5.09 -0.13,8.45 -7.41,9.11 -5.83,-3.36 -8.78,-7.01 -3.86,-11.14 3.91,-3.38 8.82,-2.83 11.26,2.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2068.6 2867.44c2.19,-3.75 6.3,-4.31 9.69,-1.56 3.61,2.94 2.83,7.1 -0.19,9.8 -1.84,1.63 -5.1,1.6 -8.95,1.06 -1.09,-3.97 -1.73,-7.16 -0.55,-9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M3009.77 1221.87c3.09,-4.69 7.54,-4.89 12.32,0.86 -0.59,7.33 -4.02,10.33 -9.46,8.5 -4.03,-1.45 -5.11,-5.95 -2.86,-9.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2346.84 739.74c-3.56,2.99 -7,1.52 -9.29,-2.01 -1.66,-2.66 -0.97,-5.44 2.93,-8.02 3.07,0.53 4.89,1.29 6.12,2.62 2.1,2.25 2.65,5.39 0.24,7.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1373.84 1510.59c-3.37,2.62 -7.45,2.8 -9.81,-1.22 -2.22,-3.74 -0.5,-7.34 3.1,-9.76 0.76,-0.5 1.81,-0.7 4.59,-0.76 7.11,4 6.72,8.09 2.12,11.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1624.73 1285.72c2.5,-2 5.48,-0.69 7.08,1.65 3.18,4.8 2.18,8.48 -5.33,9.64 -6.27,-3.87 -6.23,-7.77 -1.75,-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1421.25 1683.83c5.08,3.02 5.47,7.31 -0.61,11.98 -3.54,-0.43 -6.01,-0.7 -6.84,-2.09 -1.44,-2.16 -3.17,-5.66 -2.33,-7.44 1.82,-3.95 6.23,-4.57 9.79,-2.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1623.39 1254.05c2.82,-4.23 6.55,-3.2 9.86,-0.66 1.42,1.15 2.23,3.08 3.05,6.45 -1.99,4.38 -4.66,5.79 -7.6,5.01 -5.64,-1.54 -8.05,-6.5 -5.3,-10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2076.25 2651.22c2.65,-3.76 6.09,-3.41 9.24,-0.71 1.27,1.11 1.92,2.94 2.63,6.2 -2.53,2.73 -5.11,4.94 -7.04,4.55 -5.49,-1.27 -7.58,-6.16 -4.83,-10.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1734.85 2606.54c1.5,0.37 3.32,1.76 3.92,3.12 1.89,4.26 -0.91,6.9 -4.22,8.72 -1.46,0.79 -3.49,0.46 -6.54,-0.54 -1.43,-2.92 -2.13,-4.87 -1.59,-6.4 1.37,-3.8 4.29,-5.93 8.44,-4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M3050.18 786.09c2.53,3.34 2.73,6.73 -2.49,10.2 -3.94,-1.05 -6.7,-2.15 -8.25,-4.16 -1.74,-2.36 -1.27,-5.61 1.15,-7.53 3.51,-2.84 6.99,-1.86 9.6,1.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1055.81 779.17c-3.94,2.45 -7.17,0.17 -8.99,-3.52 -1.29,-2.65 -0.79,-5.46 3.18,-7.95 3.22,0.37 5.31,0.78 6.43,2.13 2.69,3.1 3.39,6.91 -0.62,9.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M802.72 1440.32c-3.89,-1.04 -6.57,-2.18 -8.19,-4.25 -1.84,-2.37 -1.51,-5.74 1.25,-7.16 2.15,-1.11 5.8,-1.81 7.54,-0.72 4.73,3.05 4.78,7.35 -0.6,12.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1450.45 1625.62c-3.44,1.94 -7.34,1.85 -9.66,-1.58 -1.33,-1.97 -1.02,-4.99 -0.28,-9.02 3.79,-1.29 6.98,-2 8.8,-0.7 4.56,3.33 4.92,9.15 1.14,11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1940.9 802.85c3.41,4.7 4.19,8.65 0.02,10.32 -5.27,2.11 -11.44,-3.47 -10.04,-9.15 1.07,-4.3 5.08,-4.3 10.02,-1.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2871.62 2630.33c0.01,-6.03 2.3,-9.49 6.62,-8.11 3.95,1.24 5.44,5.66 3.3,9.31 -2.29,3.87 -5.99,3.82 -9.92,-1.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1230.27 1457.91c-5.84,-0.21 -9.4,-2.59 -8.29,-6.55 1.16,-3.87 5.88,-4.66 9.35,-2.84 4.01,2.15 3.75,5.7 -1.07,9.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1781.22 630.88c1.92,4.2 -1.28,6.26 -6.9,6.77 -5.16,-3.14 -5.82,-6.52 -2.22,-9.02 3.22,-2.3 7.5,-1.3 9.12,2.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M3002.6 232.29c2.97,3.19 3.33,7.53 -0.65,9.56 -4.37,2.23 -6.7,-1.14 -7.28,-5.41 -0.08,-0.93 0.3,-1.92 1.61,-4.15 2.94,-0.93 5.3,-1.1 6.31,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2822.43 1132.56c3.15,-0.03 5.67,2.13 5.04,5.51 -0.93,4.61 -4.37,5.74 -9.88,3.18 -1.98,-5.99 0.23,-8.61 4.83,-8.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1872.75 1668.45c3.1,0.57 5.27,2.65 4.5,5.9 -0.34,1.42 -2.31,2.97 -3.87,3.6 -2.88,1.13 -5.49,-0.07 -7.56,-4.21 1.41,-4.44 3.86,-5.75 6.93,-5.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2371.09 1894.1c-4.52,1.56 -6.91,-0.5 -6.03,-6.64 5.27,-3.75 7.99,-2.01 8.74,2.5 0.17,1.25 -1.41,3.73 -2.7,4.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1865.21 1473.53c7.12,-1.63 9.89,1.04 8.57,6.82 -0.65,2.82 -3.46,4.7 -6.19,3.6 -3.83,-1.57 -4.68,-5.2 -2.37,-10.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1840.6 896.15c-3.25,2.48 -7.58,1.46 -9.18,-2.25 -1.75,-4.07 1.27,-6.61 7,-7.31 5.09,3.34 5.69,6.93 2.18,9.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M657.95 1993.52c1.71,4 -1.3,6.52 -7,7.23 -5.19,-3.22 -5.35,-6.8 -2.08,-9.29 3.19,-2.5 7.52,-1.53 9.07,2.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2392.44 2043.88c-0.57,-0.98 0.35,-3.44 1.35,-4.35 2.32,-2.02 4.96,-1.27 7.19,0.42 0.66,0.5 0.92,1.47 0.79,3.58 -3.88,3.85 -7.1,4.37 -9.34,0.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M3151.06 603.8c-1.58,-2.65 -1.09,-6.08 1.69,-7.57 4.52,-2.36 6.82,0.42 7.59,6.35 -3.58,5.49 -6.78,5.38 -9.28,1.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2684.23 818.73c0.33,-1.6 1.92,-2.94 4.83,-4.58 3.01,1.19 4.76,2.31 5.27,3.88 1.3,4.06 0.06,7.61 -4.59,7.95 -4.75,0.37 -6.3,-3.07 -5.51,-7.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2845.54 979.95c-2.35,-3.38 -1.79,-8.16 2,-9.83 4.16,-1.82 6.77,1.52 7.5,7.54 -3.27,5.5 -6.9,6.02 -9.5,2.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2823.88 1578.59c-3.26,-4.83 -2.98,-8.45 0.75,-10.39 2.51,-1.37 5.59,0.05 6.68,2.69 2.26,5.52 -0.14,8.5 -7.44,7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2783.29 424.34c2.75,1.87 3.04,5.03 0.4,7.34 -3.48,3.02 -6.86,2.07 -9.86,-3.01 2.34,-5.55 5.66,-6.94 9.46,-4.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1550.05 2344.15c5.23,-3.75 7.97,-2.04 8.66,2.52 0.19,1.36 -1.35,3.82 -2.65,4.28 -4.67,1.58 -6.78,-0.83 -6.01,-6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1265.05 1910.55c1.86,2.36 1.48,5.77 -1.08,7.49 -3.71,2.51 -7.08,1.08 -9.89,-4.23 3.06,-6.73 6.88,-8.43 10.98,-3.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2800.26 1003.13c2.15,-3.75 5.65,-3.47 9.22,1.18 0.04,5.72 -2.02,8.84 -6.25,7.55 -3.84,-1.18 -4.88,-5.42 -2.97,-8.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2583.11 1091.97c-0.03,-6.02 2.04,-8.94 6.78,-7.13 2.97,1.15 3.97,4.46 2.63,7.31 -1.98,4.46 -5.21,4.85 -9.41,-0.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2612.77 1587.48c-3.05,-0.05 -5.67,-2.06 -5.01,-5.3 0.96,-4.41 4.51,-5.21 9.73,-2.84 2.09,5.94 -0.35,8.12 -4.72,8.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2037.39 385.13c0.57,1.65 0.19,3.64 -1.02,6.91 -5.71,1.85 -8.53,-0.34 -9.13,-4.47 -0.49,-2.79 1.1,-5.48 3.98,-6.43 3.46,-1.15 5.22,1.28 6.17,3.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M986.54 1919.89c-1.08,3.82 -5.56,4.94 -9.03,2.92 -3.72,-2.1 -4.01,-5.52 0.85,-9.35 5.76,0.15 9.3,2.39 8.17,6.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1464.74 1935.09c-3.09,-0 -5.48,-2.16 -4.79,-5.42 0.97,-4.3 4.14,-5.66 9.55,-3.04 1.84,5.79 -0.36,8.42 -4.77,8.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1911.21 1169.39c-2.94,-4.87 -2.88,-8.64 1.27,-10.23 3.11,-1.2 5.49,1.27 5.98,4.23 0.74,4.29 -1.15,7.1 -7.25,5.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1334.06 1583.95c-0.97,0.9 -3.69,1.12 -4.76,0.41 -5.03,-3.36 -4.01,-7.18 1.54,-11.05 6.15,3.01 7.72,6.66 3.22,10.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2149.87 904.74c0.01,0.02 0.01,0.06 0.01,0.06l-0.04 0.04c0.03,-0.02 0.04,-0.07 0.02,-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2149.85 904.84c-0.11,0.19 -0.54,0.43 0,0l0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2162.85 905.14c1.36,2.5 0.91,5.8 -1.85,7.47 -3.88,2.38 -7.11,0.36 -9.44,-2.76 -1.07,-1.43 -1.22,-3.47 -1.65,-5.02 0.19,-0.15 0.5,-0.36 0.99,-0.66 6.08,-3.01 9.86,-3.01 11.95,0.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2537.66 1006.28c-4.22,1.87 -6.64,-1.39 -7.22,-7.23 3.32,-5.27 6.94,-5.89 9.47,-2.25 2.36,3.32 1.47,7.85 -2.25,9.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2911.19 988.71c1.11,-0.58 3.84,0.26 4.64,1.32 2.86,3.96 1.13,6.68 -4.55,7.79 -4.8,-3.96 -4.17,-7.1 -0.09,-9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1558.14 734.4c0.13,4.77 -3.36,6.42 -7.18,7.04 -1.7,0.31 -3.67,-0.61 -7.51,-2.62 -3.27,-7.38 -0.86,-10.89 4.67,-11.94 5.04,-0.96 9.89,2.79 10.02,7.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1387.84 1938.11c-0.22,7.11 4.02,14.09 -4.99,15.01 -6.06,0.67 -7.05,-4.6 -8.45,-8.96 -0.43,-1.32 -0.63,-2.7 0.07,-4.64 -1.13,0 -2.32,-0.04 -3.66,-0.09 -12.04,-0.05 -21.76,-0.1 -31.26,-1.5 -16.06,-2.32 -32.07,-4.26 -42.04,-20.72 -4.8,-7.9 -13.54,-13.48 -20.39,-20.21 -3.33,-3.4 -8.29,-6.62 -9.2,-10.67 -2.2,-10.17 -9.21,-16.69 -14.89,-24.5 -9.6,-13.23 -18.95,-26.72 -27.51,-40.69 -13.18,-21.49 -6.33,-44.96 22.47,-49.34 8.64,-1.28 17.24,-3.52 25.91,-0.88 7.76,2.31 15.17,1 22.93,-0.19 19.15,-3 38.28,-5.67 56.82,-11.52 9.44,-2.91 19.2,-4.33 28.68,-1.3 20.42,6.56 39.09,15.9 51.99,34.27 5.09,7.14 10.25,14.61 16.99,19.82 11.43,8.96 13.58,20.63 13.62,33.6 0,21 -8.96,39.3 -17.67,57.63 -1.57,3.35 -4.24,7.24 -7.42,8.73 -17.18,8.16 -31.33,23.26 -54.1,25.16 0.71,0.28 1.39,0.53 2.1,0.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2541.77 1574.83c-0.42,6.24 -4.24,7.4 -10.88,4.32 -2.12,-7.33 0.06,-10.53 6.12,-9.88 3.15,0.34 5.01,2.38 4.76,5.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2230.03 1634.05c-0.19,0.02 -0.2,0.08 -2.15,1.47 -3.51,2.37 -4.98,3.81 -6.66,4.05 -3.71,0.64 -7.52,0.29 -7.94,-4.61 -0.52,-5.3 3.75,-5.95 7.13,-5.44 3.48,0.59 6.6,2.94 9.62,4.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2566.26 2689.59c2.07,-3.78 5.5,-3.72 9.16,1.1 0.09,5.73 -1.87,9.2 -6.12,7.85 -3.73,-1.15 -4.9,-5.5 -3.04,-8.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M3111.84 1083.32c2.47,-1.45 5.47,0.11 6.52,2.76 2.06,5.36 0.13,8.57 -7.24,7.84 -2.96,-4.84 -2.85,-8.56 0.71,-10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2673.46 1845.94c-0.17,-2.28 2.16,-4.7 5.3,-7.28 3.57,2.08 6.14,4.16 6.23,6.48 0.1,2.14 -1.92,5.74 -3.82,6.35 -4.2,1.34 -7.36,-1.54 -7.71,-5.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2582.2 359.61c-1.64,-0.48 -3.3,-1.22 -5.09,-2.13 -3.99,-4.88 -6.48,-8.93 -8.3,-13.25 -11.59,-27.35 -11.55,-27.37 22.43,-26.99 -0.07,-0.53 -0.18,-1.07 -0.18,-1.67 3.51,-3.03 5.68,-5.06 7.08,-7.52 1.95,-3.54 3.94,-7.07 8.56,-6.3 5.48,0.96 7.88,5.35 8.49,10.36 0.72,6.22 -3.6,8.37 -8.75,9.13 -3.45,0.55 -6.82,1.05 -9.97,3.15 0.42,1.06 0.75,2.24 1.11,3.62 1.66,7.03 2.14,11.96 2.99,18.59 0.24,-0.25 0.46,-0.53 0.72,-0.75 2.86,5.14 0.61,7.29 -2.64,8.02 -0.44,0.71 -0.95,1.37 -1.56,1.95 0.05,0.23 -0.36,0.34 -1.81,1.55 0.38,0.07 0.75,0.08 1.13,0.2 -5.69,7.36 -10.89,7.02 -14.22,2.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2120.38 589.06c0,0 -0.07,-0 -0.11,0 0.06,-0 0.1,0 0.11,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2112.35 589.12c2.43,-0.77 5.34,-0.07 7.92,-0.06 -0.12,0.05 -0.23,0.31 -0.36,1.67 -0.8,3.61 -1.12,5.53 -2.06,6.96 -1.63,2.45 -4.09,3.54 -7,2.37 -2.69,-1.12 -5.04,-3.33 -4.07,-6.14 0.78,-2.03 3.34,-4.12 5.57,-4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1607.33 1548.86c-1.16,-0.68 -2.26,-3.25 -1.85,-4.41 1.47,-4.4 4.51,-4.9 8.78,-0.78 -0.41,5.68 -2.87,7.55 -6.93,5.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1579.61 964.28c-2.56,1.83 -5.56,0.85 -6.92,-1.85 -2.02,-4.08 0.13,-6.74 5.77,-7.67 4.64,3.63 4.76,6.94 1.15,9.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M447.83 1805.91c4.78,-3.11 8.36,-2.85 10.25,0.71 1.37,2.44 -0.04,5.49 -2.67,6.53 -5.34,2.15 -8.36,-0.03 -7.58,-7.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2272.97 1693.77c-3.34,1.34 -5.71,-1.05 -6.15,-4.1 -0.69,-4.5 1.54,-7.16 7.85,-6.06 3.46,5.07 2.57,8.55 -1.7,10.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2586.78 813.24c-7.1,1.65 -10.3,-0.68 -8.73,-6.64 0.73,-2.77 3.71,-4.57 6.37,-3.59 4.03,1.47 4.84,5.03 2.36,10.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2196.21 1744.01c1.86,6.92 -0.31,10.03 -6.11,9.46 -2.93,-0.31 -5.15,-2.22 -4.89,-5.29 0.48,-6.19 4.65,-6.75 11.01,-4.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1559.89 633.32c1.83,-0.15 5.55,2.48 5.76,4.16 0.65,6 -3.14,7.6 -9.7,5.13 -1.8,-5.51 -0.21,-8.88 3.94,-9.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1723.45 752.24c1.36,2.28 1.73,5.12 1.13,9.12 -6,1.78 -8.63,-0.76 -9.48,-4.86 -0.61,-2.81 0.33,-5.87 3.46,-6.52 1.49,-0.29 4.1,0.91 4.89,2.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2637.37 1927.24c0.44,0.69 0.85,1.46 1.12,2.46 -2.3,6.18 -3.74,10.52 -5.33,14.87 -1.76,4.87 -4.78,8.17 -10.39,6.38 -5.59,-1.8 -8.58,-8.01 -5.86,-13.49 1.91,-3.72 5.43,-6.75 10.21,-11.25 -0.64,-0.22 -1.29,-0.43 -1.98,-0.75 -0.37,-2.32 -0.23,-3.37 1.11,-5.73 -0.33,0.01 -0.68,-0.02 -1,-0.22 1.71,-2.24 3.27,-3.12 4.39,-3.04 0.73,-0.54 1.55,-1.02 2.69,-1.52 10.62,3.97 10.94,4.32 5.04,12.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1791.55 1848.87c2.97,0.22 4.09,2.45 2.78,6.64 -3.87,1.89 -6.23,1.07 -6.97,-1.77 -0.7,-3.08 1.11,-5.05 4.19,-4.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1087.83 1558.11c-2.13,2.86 -4.74,1.95 -7.06,-2 1.67,-4.51 4.2,-5.32 6.6,-2.83 0.9,0.94 1.19,3.82 0.46,4.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1758.81 1726.24c-2.68,5.43 -5.73,5.38 -8.25,1.71 -0.58,-0.95 0.15,-3.8 1.18,-4.64 2.44,-1.92 4.91,-0.96 7.07,2.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1727.73 1029.55c-0.9,0.91 -3.76,1.06 -4.77,0.29 -2.72,-2.07 -2.38,-4.7 1.83,-7.02 4.49,1.79 5.31,4.33 2.94,6.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2840.96 249.8c-0.22,3.18 -2.8,4.26 -7.24,2.98 -1.82,-4.12 -1.07,-6.79 2.04,-7.56 3.35,-0.78 5.43,1.32 5.21,4.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1678.09 529.83c-0.05,0.91 -2.54,2.48 -3.73,2.34 -2.94,-0.33 -4.16,-2.56 -3.03,-6.78 5.83,-2.44 6.91,0.7 6.76,4.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2432.23 1856.09c0.04,1.27 -1.77,3.48 -2.98,3.67 -3.39,0.44 -4.87,-1.76 -3.73,-6.26 4.24,-1.88 6.67,-0.85 6.71,2.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2413.83 2073.32c-0.01,-1.25 1.84,-3.43 3.11,-3.59 3.37,-0.49 4.93,1.66 3.71,6.24 -4.25,1.83 -6.7,0.77 -6.82,-2.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1515.42 1734.8c3.13,-0.03 5.43,1.5 5.76,4.76 0.52,5.28 -2.8,6.18 -8.72,4.31 -2.71,-5.55 -2.56,-9.03 2.96,-9.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1675.51 1617.02c-2.03,2.68 -4.57,1.89 -6.88,-1.91 1.68,-4.39 4.13,-5.03 6.48,-2.72 0.84,0.91 1.15,3.69 0.41,4.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2359.91 2354.18c1.07,-0.12 2.96,1.88 3.19,3.13 0.48,3.12 -1.16,4.92 -5.75,3.48 -1.65,-4.02 -0.58,-6.38 2.56,-6.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2100.02 2608.54c5.34,-2.02 9.35,-2.15 9.61,3.33 0.14,3.35 -2,5.24 -5.08,5.59 -5.54,0.75 -5.93,-3.16 -4.53,-8.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2289.32 1738.83c3.25,-3.72 6.23,-1.83 9.27,3.11 -2.38,5.14 -5.34,6.96 -8.95,3.82 -2.36,-2.02 -2.37,-4.64 -0.33,-6.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2196.18 101.42c4.1,1.77 5.13,4.05 2.78,6.4 -0.8,0.83 -3.51,0.98 -4.45,0.22 -2.44,-1.91 -2.2,-4.44 1.68,-6.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M849.87 3054.07c5.57,2.52 6.73,5.57 3.05,8.73 -1.07,0.84 -3.8,1.06 -4.88,0.28 -3.77,-2.67 -3.36,-5.91 1.83,-9.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2266.58 2018.95c-1.96,4.05 -4.98,4.49 -8.32,-0.63 1.59,-4.18 3.94,-5.43 6.57,-3.84 1.12,0.72 2.29,3.43 1.75,4.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2203.15 1610.56c-1.32,-0.14 -3.14,-1.87 -3.46,-3.18 -1.24,-4.82 2.29,-5.72 7.33,-4.9 1.27,4.83 1.2,8.67 -3.87,8.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2161.32 960.77c1.67,-4.28 4.12,-5.05 6.46,-2.73 0.83,0.78 0.95,3.54 0.23,4.49 -1.98,2.48 -4.46,2.26 -6.69,-1.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2158.47 993.81c0.88,0.9 1.14,3.66 0.39,4.57 -2.05,2.66 -4.54,2.06 -6.83,-1.92 1.65,-4.43 4.15,-4.89 6.44,-2.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2049.77 739.09c-0.02,-1.15 1.86,-3.3 2.99,-3.42 3.26,-0.37 4.81,1.83 3.77,6.19 -4.15,1.55 -6.62,0.55 -6.76,-2.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1673.78 2587.07c-2.08,-3.93 -1.29,-6.33 1.67,-7 3.01,-0.69 5.16,1.03 4.94,4.19 -0.19,2.96 -2.41,4.19 -6.61,2.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2090.72 1155.03c-0.93,1.02 -1.96,1.98 -3.38,3.02 -24.22,16.14 -33.06,15.15 -50.29,-3.13 -5.48,-5.84 -8.48,-12.3 -10.62,-22.72 -0.09,0.52 -0.17,1.1 -0.29,1.62 -3.22,-7.54 -6.63,-14.34 -0.94,-18.24 0.36,-1.93 0.86,-3.9 1.46,-6.03 1.15,-10.89 4.84,-16.38 14.51,-15.9 17.47,0.86 32.8,6.59 46.7,20.89 0.15,0.12 0.28,0.28 0.41,0.4 0.11,-0.23 0.16,-0.48 0.24,-0.71 12.15,1.41 21.64,0.04 30.27,-3.23 0.57,-1.71 1.27,-3.49 2.11,-5.37 1.75,-5.86 3.33,-9.77 4.97,-15.28 -0.28,0.05 -0.55,0.12 -0.88,0.12 -2.65,-3.27 -4.65,-4.99 -6.29,-6.98 -0.95,-1.1 -1.49,-2.65 -2.19,-4.05 1.52,-0.24 3.03,-0.79 4.51,-0.69 3.06,0.26 6.19,0.75 9.42,2.14 0.86,-0.71 1.83,-1.4 2.98,-2.06 8.02,1.05 13.88,4.44 20.09,5.27 14.01,1.98 24.11,9.43 34.02,21.77 0.1,-0.48 0.15,-0.94 0.29,-1.43 4.39,7.54 11.26,13.97 7.26,20.99 0.07,2.1 -0.14,4.29 -0.81,6.71 -4.5,9.26 -8.09,16.74 -13.95,23.03 -5.26,5.71 -10.68,6.67 -17.4,4.54 -3.54,-1.18 -6.99,-2.64 -11.66,-2.4 -0.01,0.01 -0.04,0.05 -0.07,0.09 0.12,0.1 0.2,0.14 0.31,0.24 -1.25,3.74 -1.61,5.66 -2.04,7.52 -2.55,14.15 -4.64,16.26 -14.88,10.22 -1.91,-0.24 -4.03,-0.81 -6.58,-1.85 -2.63,-1.6 -3.51,-3.11 -4.96,-7.19 -0.14,0.56 -0.19,1.12 -0.35,1.64 -5.63,-6.83 -7.72,-13.05 -1.62,-16.81 0.37,-1.79 0.9,-3.66 1.51,-5.67 0.43,-6.12 0.61,-10.23 -1.01,-16.19 -0.11,-0.16 -0.16,-0.32 -0.27,-0.5 -0.1,0.58 -0.15,1.14 -0.31,1.68 -9.47,0.97 -16.97,2.41 -25.16,2.79 -0.21,1.14 -0.48,2.28 -0.81,3.52 0.06,4.08 -0.28,6.45 -0.6,10.37 0.26,-0.16 0.46,-0.39 0.72,-0.56 0.34,4.87 -0.7,8.24 -4.42,8.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1453.47 2332.14c-1,0.81 -3.7,0.89 -4.84,0.11 -3.87,-2.55 -3.52,-5.63 1.83,-8.67 5.35,2.49 6.82,5.45 3.01,8.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2506.98 1333.06c-1.98,4.23 -5.18,4.74 -8.63,-0.62 1.68,-4.4 4.19,-5.68 6.85,-4 1.2,0.72 2.32,3.51 1.78,4.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1940.04 779.71c0.18,-3.06 2.47,-4.26 6.77,-2.77 1.91,3.95 1.29,6.44 -1.73,7.15 -3.13,0.67 -5.24,-1.27 -5.04,-4.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1458.21 1267.72c4.24,1.64 5.23,4 2.78,6.38 -0.9,0.92 -3.66,1.16 -4.63,0.45 -2.81,-2.04 -1.91,-4.55 1.86,-6.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1038.32 1314.77c-5.32,1.79 -7.61,0.02 -7.33,-4.38 0.07,-0.66 1.11,-1.67 1.85,-1.82 4.03,-0.98 6.76,0.01 5.48,6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2666.17 1026.89c1.24,0.04 3.34,1.82 3.5,2.99 0.52,3.3 -1.58,4.74 -5.96,3.47 -1.82,-4.1 -0.89,-6.45 2.46,-6.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1994.44 1680.67c-1.91,-3.85 -1.27,-6.29 1.65,-6.91 3.07,-0.65 5.16,1.22 5.02,4.3 -0.14,3.05 -2.5,3.98 -6.67,2.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2427.04 1683.73c2.62,2.07 1.99,4.67 -1.8,6.97 -4.21,-1.82 -5.3,-4.18 -2.81,-6.62 0.84,-0.86 3.66,-1.08 4.61,-0.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M254.74 896.76c-1.7,4.41 -4.15,5.01 -6.46,2.73 -0.9,-0.84 -1.12,-3.66 -0.37,-4.61 2.02,-2.63 4.57,-2.14 6.83,1.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2356.09 567.11c4.12,-1.92 6.34,-0.64 6.52,2.57 0.02,1.21 -1.72,3.37 -2.83,3.48 -3.23,0.42 -4.78,-1.63 -3.68,-6.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2737.61 1105.76c4.24,-1.88 6.6,-0.81 6.67,2.61 -0,1.26 -1.88,3.37 -3.13,3.55 -3.33,0.51 -4.87,-1.6 -3.54,-6.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1808.91 803.59c-2.06,-4.06 -1.37,-6.74 1.76,-7.41 3.24,-0.73 5.43,1.36 5.26,4.59 -0.2,3.17 -2.61,4.36 -7.02,2.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1494.7 1893.92c4.56,1.62 5.26,3.92 2.84,6.15 -0.86,0.79 -3.6,0.78 -4.65,0 -2.53,-1.83 -2.67,-4.26 1.8,-6.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2457.35 338.48c0.59,0.41 0.29,3.47 -0.57,4.19 -1.89,1.65 -4.41,2.53 -6.64,3.08 0,-0.67 0.14,-2.01 0.64,-3.49 1.97,-3.82 3.81,-5.75 6.57,-3.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M441.64 1421.76c-3.43,1.64 -6.83,1.74 -5.36,-1.84 1.18,-2.86 4.23,-1.77 5.36,1.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2421.49 1889.23c1.49,-0.77 2.91,-1.57 5.38,-1.45 0.35,3.12 -1.1,4.02 -3.35,3.22 -0.79,-0.28 -1.36,-1.19 -2.04,-1.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2339.68 1242.15l-0.04 0.12c0,0 -0.01,-0.08 0.04,-0.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2339.99 1242.28c-0.15,-0.12 -0.25,-0.13 -0.31,-0.13 0.11,-0.13 0.45,-1.04 0.45,-1.04 0,0 0.26,1.47 -0.14,1.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1700.76 1951.32c-2.79,-0.66 -4.45,-2.6 -3.92,-3.65 1.63,-3.52 4.14,-1.85 6.12,0.47 -0.34,0.77 0,2.39 -2.2,3.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1818.48 624.24c0,0 -0.08,0.04 -0.1,0.04 0.06,-0.1 0.1,-0.09 0.1,-0.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M1818.09 624.83c-0.29,0.63 -1.92,0.9 -1.92,0.9 0,0 1.97,-1.27 2.21,-1.45 -0.06,0.09 -0.16,0.24 -0.29,0.55z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSplashWhite1);
export default __webpack_public_path__ + "static/media/homeSplashWhite1.948f10e801631919e017f3b44a725b87.svg";
export { ForwardRef as ReactComponent };